import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type PapiGqlAcknowledgement = {
  __typename?: 'Acknowledgement';
  expired?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PapiGqlAcknowledgementType>;
};

export enum PapiGqlAcknowledgementType {
  Gdpr = 'GDPR',
  Skyspecs = 'SKYSPECS'
}

export type PapiGqlAdjacentPictures = {
  __typename?: 'AdjacentPictures';
  base?: Maybe<PapiGqlPicture>;
  clockwise?: Maybe<PapiGqlPicture>;
  closer?: Maybe<PapiGqlPicture>;
  counterclockwise?: Maybe<PapiGqlPicture>;
  current?: Maybe<PapiGqlPicture>;
  further?: Maybe<PapiGqlPicture>;
  opposingSide?: Maybe<PapiGqlPicture>;
  tip?: Maybe<PapiGqlPicture>;
};

export type PapiGqlAnnotation = {
  __typename?: 'Annotation';
  annotationStatus?: Maybe<Scalars['String']['output']>;
  blade?: Maybe<Scalars['String']['output']>;
  bladeSide?: Maybe<Scalars['String']['output']>;
  damageDepth?: Maybe<Scalars['String']['output']>;
  damageGroup?: Maybe<PapiGqlDamageGroup>;
  damageShape?: Maybe<PapiGqlDamageShape>;
  damageShapes?: Maybe<Array<Maybe<PapiGqlDamageShape>>>;
  damageSizeChord?: Maybe<Scalars['String']['output']>;
  damageSizeSpan?: Maybe<Scalars['String']['output']>;
  damageType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  horizonLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inspection?: Maybe<PapiGqlInspection>;
  isNewest?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<PapiGqlLocation>;
  picture?: Maybe<PapiGqlPicture>;
  pictures?: Maybe<Array<Maybe<PapiGqlPicture>>>;
  radialDistance?: Maybe<Scalars['Float']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  tower?: Maybe<PapiGqlTower>;
};

export type PapiGqlAnnotationObservation = PapiGqlObservation & PapiGqlPhotogenic & {
  __typename?: 'AnnotationObservation';
  annotationType?: Maybe<PapiGqlAnnotationTypeReference>;
  attrs?: Maybe<Scalars['JSON']['output']>;
  blade: PapiGqlBlade;
  bladeSide?: Maybe<Scalars['String']['output']>;
  componentAffected?: Maybe<PapiGqlComponentReference>;
  coordinates?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
  customerId: Scalars['ID']['output'];
  damages?: Maybe<Array<Maybe<PapiGqlDamage>>>;
  /** @deprecated Use 'annotationType' instead */
  damageType?: Maybe<PapiGqlAnnotationTypeReference>;
  descriptors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  droneIdLogId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCritical?: Maybe<Scalars['Boolean']['output']>;
  materialAffected?: Maybe<PapiGqlMaterialReference>;
  observationId: Scalars['ID']['output'];
  picture?: Maybe<PapiGqlPicture>;
  size?: Maybe<PapiGqlAnnotationObservationSize>;
  skyspecsSeverity?: Maybe<Scalars['Int']['output']>;
  type: PapiGqlObservationType;
};

export type PapiGqlAnnotationObservationSize = {
  __typename?: 'AnnotationObservationSize';
  chord?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  span?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type PapiGqlAnnotationsResponseObject = {
  __typename?: 'AnnotationsResponseObject';
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PapiGqlAnnotation>>>;
};

export enum PapiGqlAnnotationTypeReference {
  Bolts = 'BOLTS',
  Bondline = 'BONDLINE',
  Chip = 'CHIP',
  Crack = 'CRACK',
  Damaged = 'DAMAGED',
  DamagedCover = 'DAMAGED_COVER',
  DamagedOrMisaligned = 'DAMAGED_OR_MISALIGNED',
  DamagedOrObstructed = 'DAMAGED_OR_OBSTRUCTED',
  Delamination = 'DELAMINATION',
  Discoloration = 'DISCOLORATION',
  Erosion = 'EROSION',
  Flaking = 'FLAKING',
  Holes = 'HOLES',
  IceCondensation = 'ICE_CONDENSATION',
  Missing = 'MISSING',
  Other = 'OTHER',
  Peeling = 'PEELING',
  Pinholes = 'PINHOLES',
  Scratch = 'SCRATCH',
  TransitionLine = 'TRANSITION_LINE'
}

export type PapiGqlAttachment = {
  __typename?: 'Attachment';
  contentType?: Maybe<Scalars['String']['output']>;
  created: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  customerId: Scalars['ID']['output'];
  extension?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: PapiGqlPermissions;
  recordId: Scalars['ID']['output'];
  s3Key: Scalars['String']['output'];
  updated?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type PapiGqlAuthor = PapiGqlCommentAuthor | PapiGqlUser;

export enum PapiGqlAuxiliaryComponent {
  ChordExtensions = 'CHORD_EXTENSIONS',
  LeadingEdgeProtection = 'LEADING_EDGE_PROTECTION',
  LpsDiverterStrips = 'LPS_DIVERTER_STRIPS',
  Serrations = 'SERRATIONS',
  Spoilers = 'SPOILERS',
  VortexGenerators = 'VORTEX_GENERATORS'
}

export type PapiGqlAuxiliaryComponentNode = {
  __typename?: 'AuxiliaryComponentNode';
  id: PapiGqlAuxiliaryComponent;
  name: Scalars['String']['output'];
};

export type PapiGqlBlade = PapiGqlNode & PapiGqlTaskAsset & {
  __typename?: 'Blade';
  auxiliaryComponents: Array<Maybe<PapiGqlAuxiliaryComponent>>;
  damages: Array<PapiGqlDamage>;
  id: Scalars['ID']['output'];
  label?: Maybe<PapiGqlBladeLabel>;
  length?: Maybe<Scalars['String']['output']>;
  location?: Maybe<PapiGqlLocation>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'turbine' or 'location' instead */
  parent?: Maybe<PapiGqlTower>;
  serial?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PapiGqlBladeStatus>;
  turbine?: Maybe<PapiGqlTurbine>;
};

export enum PapiGqlBladeChamber {
  BetweenWeb_1 = 'BETWEEN_WEB_1',
  BetweenWeb_2 = 'BETWEEN_WEB_2',
  LeadingEdge = 'LEADING_EDGE',
  Root = 'ROOT',
  TrailingEdge = 'TRAILING_EDGE'
}

export type PapiGqlBladeChamberValue = {
  __typename?: 'BladeChamberValue';
  abbreviated: Scalars['String']['output'];
  id: PapiGqlBladeChamber;
  label: Scalars['String']['output'];
};

export enum PapiGqlBladeLabel {
  A = 'A',
  B = 'B',
  C = 'C'
}

export type PapiGqlBladeList = PapiGqlList & {
  __typename?: 'BladeList';
  items?: Maybe<Array<Maybe<PapiGqlBlade>>>;
  totalCount: Scalars['Int']['output'];
};

export enum PapiGqlBladeSide {
  LeadingEdge = 'LEADING_EDGE',
  PressureSide = 'PRESSURE_SIDE',
  SuctionSide = 'SUCTION_SIDE',
  TrailingEdge = 'TRAILING_EDGE'
}

export type PapiGqlBladeSideValue = {
  __typename?: 'BladeSideValue';
  abbreviated: Scalars['String']['output'];
  id: PapiGqlBladeSide;
  label: Scalars['String']['output'];
};

export enum PapiGqlBladeStatus {
  Active = 'ACTIVE',
  InactiveEol = 'INACTIVE_EOL',
  InactiveStorage = 'INACTIVE_STORAGE'
}

export type PapiGqlBulkCreateInspectionInput = {
  inspections?: InputMaybe<Array<PapiGqlCreateInspectionInput>>;
};

export type PapiGqlComment = {
  __typename?: 'Comment';
  author: PapiGqlAuthor;
  comment: Scalars['String']['output'];
  /** @deprecated Use 'timestamp' instead */
  created: Scalars['String']['output'];
  /** @deprecated Use 'user' instead */
  createdBy?: Maybe<PapiGqlUser>;
  id: Scalars['ID']['output'];
  isEdited: Scalars['Boolean']['output'];
  permissions: PapiGqlPermissions;
  threadId: Scalars['ID']['output'];
  timestamp: Scalars['String']['output'];
  /** @deprecated Use 'timestamp' instead */
  updated?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'user' instead */
  updatedBy?: Maybe<PapiGqlUser>;
};

export type PapiGqlCommentAuthor = {
  __typename?: 'CommentAuthor';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum PapiGqlComponentReference {
  Blade = 'BLADE',
  DrainageSystem = 'DRAINAGE_SYSTEM',
  GurneyFlaps = 'GURNEY_FLAPS',
  Hub = 'HUB',
  LeadingEdgeProtection = 'LEADING_EDGE_PROTECTION',
  LightningReceptors = 'LIGHTNING_RECEPTORS',
  Nacelle = 'NACELLE',
  NoiseStrips = 'NOISE_STRIPS',
  Other = 'OTHER',
  PitchSystem = 'PITCH_SYSTEM',
  RainCollar = 'RAIN_COLLAR',
  Seals = 'SEALS',
  Serrations = 'SERRATIONS',
  Spoilers = 'SPOILERS',
  TipBrakeSystem = 'TIP_BRAKE_SYSTEM',
  Tower = 'TOWER',
  VortexGenerators = 'VORTEX_GENERATORS'
}

export enum PapiGqlCoverageType {
  Portal = 'PORTAL',
  Qc = 'QC'
}

export type PapiGqlCreateCommentInput = {
  comment: Scalars['String']['input'];
  threadId: Scalars['ID']['input'];
};

export type PapiGqlCreateInspectionCampaignInput = {
  inspectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
};

export type PapiGqlCreateInspectionInput = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  deadline?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inspectionDate: Scalars['String']['input'];
  inspectionHardware?: InputMaybe<Scalars['String']['input']>;
  inspector?: InputMaybe<Scalars['String']['input']>;
  purchaseOrder?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  turbineId: Scalars['ID']['input'];
  turbineLatLong?: InputMaybe<PapiGqlLatLongInput>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type PapiGqlCreateInspectionUploadImageInput = {
  assetDescriptors?: InputMaybe<Scalars['JSON']['input']>;
  bladeDescriptors?: InputMaybe<Scalars['JSON']['input']>;
  bladeId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  uploadId: Scalars['ID']['input'];
  usePathHint?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PapiGqlCreateInspectionUploadInput = {
  description: Scalars['String']['input'];
  inspectionDate: Scalars['String']['input'];
  taskId?: InputMaybe<Scalars['ID']['input']>;
  turbineId?: InputMaybe<Scalars['ID']['input']>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type PapiGqlCreateLogFieldInput = {
  displayName: Scalars['String']['input'];
  formula?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stats?: InputMaybe<PapiGqlLogStatsInput>;
  type: PapiGqlLogFieldType;
};

export type PapiGqlCreateNotificationInput = {
  link?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  type: PapiGqlNotificationType;
};

export type PapiGqlCreateWorkLogInput = {
  date: Scalars['String']['input'];
  entry?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
};

export type PapiGqlCustomer = {
  __typename?: 'Customer';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type PapiGqlDamage = PapiGqlNode & {
  __typename?: 'Damage';
  annotation?: Maybe<PapiGqlAnnotation>;
  attrs?: Maybe<Scalars['JSON']['output']>;
  blade?: Maybe<PapiGqlBlade>;
  comments: Array<PapiGqlComment>;
  damageGroup: Array<PapiGqlDamage>;
  id: Scalars['ID']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  number?: Maybe<Scalars['String']['output']>;
  observations?: Maybe<Array<Maybe<PapiGqlObservation>>>;
  outputAttrs?: Maybe<Scalars['JSON']['output']>;
  tasks?: Maybe<Array<Maybe<PapiGqlTask>>>;
  /** @deprecated Use 'turbine' instead */
  tower?: Maybe<PapiGqlTower>;
  turbine?: Maybe<PapiGqlTurbine>;
};

export type PapiGqlDamageGroup = {
  __typename?: 'DamageGroup';
  annotations?: Maybe<Array<Maybe<PapiGqlAnnotation>>>;
  id: Scalars['ID']['output'];
};

export type PapiGqlDamageList = PapiGqlList & {
  __typename?: 'DamageList';
  /** @deprecated Use 'offset' to page results */
  cursor?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<PapiGqlDamage>>>;
  totalCount: Scalars['Int']['output'];
};

export type PapiGqlDamageShape = {
  __typename?: 'DamageShape';
  annotationId?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
  id: Scalars['ID']['output'];
  pictureId?: Maybe<Scalars['String']['output']>;
  x1?: Maybe<Scalars['Float']['output']>;
  x2?: Maybe<Scalars['Float']['output']>;
  x3?: Maybe<Scalars['Float']['output']>;
  x4?: Maybe<Scalars['Float']['output']>;
  y1?: Maybe<Scalars['Float']['output']>;
  y2?: Maybe<Scalars['Float']['output']>;
  y3?: Maybe<Scalars['Float']['output']>;
  y4?: Maybe<Scalars['Float']['output']>;
};

export type PapiGqlDeleteInspectionUploadsInput = {
  ids: Array<Scalars['ID']['input']>;
  inspectionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PapiGqlDeleteInspectionUploadsPayload = {
  __typename?: 'DeleteInspectionUploadsPayload';
  inspectionUploads?: Maybe<Array<PapiGqlInspectionUpload>>;
};

export type PapiGqlFeatureList = {
  __typename?: 'FeatureList';
  SISENSE: Scalars['Boolean']['output'];
  WORK_ORDERS: Scalars['Boolean']['output'];
};

export type PapiGqlFilterBy = {
  key: Scalars['String']['input'];
  operator?: InputMaybe<PapiGqlFilterOperator>;
  values: Array<InputMaybe<Scalars['String']['input']>>;
};

export enum PapiGqlFilterOperator {
  ArrayIncludes = 'ARRAY_INCLUDES',
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotEquals = 'NOT_EQUALS'
}

export type PapiGqlImage = {
  __typename?: 'Image';
  dziSchema?: Maybe<Scalars['JSON']['output']>;
  qcUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated use 'dziSchema' for tiling information */
  tileSourceUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  zoomifySchema?: Maybe<Scalars['JSON']['output']>;
};

export type PapiGqlImageFilter = {
  __typename?: 'ImageFilter';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type PapiGqlInspection = {
  __typename?: 'Inspection';
  /** @deprecated Field no longer supported */
  annotations?: Maybe<Array<Maybe<PapiGqlAnnotation>>>;
  campaign?: Maybe<PapiGqlInspectionCampaign>;
  /** @deprecated Field no longer supported */
  coverage?: Maybe<PapiGqlInspectionCoverage>;
  damages?: Maybe<Array<Maybe<PapiGqlDamage>>>;
  deadline?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inspectionDate?: Maybe<Scalars['String']['output']>;
  inspectionHardware?: Maybe<Scalars['String']['output']>;
  /** @deprecated All inspections will be RELEASED */
  inspectionStatus?: Maybe<Scalars['String']['output']>;
  inspector?: Maybe<Scalars['String']['output']>;
  location?: Maybe<PapiGqlLocation>;
  /** @deprecated Field no longer supported */
  observations?: Maybe<Array<Maybe<PapiGqlObservation>>>;
  permissions: PapiGqlPermissions;
  /** @deprecated Use atlas/obs svc */
  pictures?: Maybe<Array<Maybe<PapiGqlPicture>>>;
  purchaseOrder?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  task?: Maybe<PapiGqlTask>;
  timeInterval?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  tower?: Maybe<PapiGqlTower>;
  turbine?: Maybe<PapiGqlTurbine>;
  type?: Maybe<PapiGqlInspectionType>;
  vendor: PapiGqlVendor;
};


export type PapiGqlInspectionCoverageArgs = {
  type?: InputMaybe<PapiGqlCoverageType>;
};


export type PapiGqlInspectionPicturesArgs = {
  blade?: InputMaybe<PapiGqlBladeLabel>;
  bladeChamber?: InputMaybe<PapiGqlBladeChamber>;
  bladeSide?: InputMaybe<PapiGqlBladeSide>;
  distance?: InputMaybe<Scalars['Float']['input']>;
};

export type PapiGqlInspectionCampaign = {
  __typename?: 'InspectionCampaign';
  id: Scalars['ID']['output'];
  inspections: Array<PapiGqlInspection>;
  name: Scalars['String']['output'];
};

export type PapiGqlInspectionCoverage = {
  __typename?: 'InspectionCoverage';
  bladeA?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  bladeB?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  bladeC?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  progress?: Maybe<Scalars['Float']['output']>;
};

export type PapiGqlInspectionInput = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  deadline?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  inspectionDate?: InputMaybe<Scalars['String']['input']>;
  inspectionHardware?: InputMaybe<Scalars['String']['input']>;
  inspector?: InputMaybe<Scalars['String']['input']>;
  purchaseOrder?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  turbineId?: InputMaybe<Scalars['ID']['input']>;
  turbineLatLong?: InputMaybe<PapiGqlLatLongInput>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type PapiGqlInspectionList = {
  __typename?: 'InspectionList';
  items?: Maybe<Array<PapiGqlInspection>>;
  totalCount: Scalars['Int']['output'];
};

export type PapiGqlInspectionListFilters = {
  __typename?: 'InspectionListFilters';
  campaign?: Maybe<Array<Scalars['String']['output']>>;
  type?: Maybe<Array<Scalars['String']['output']>>;
  vendor?: Maybe<Array<Scalars['String']['output']>>;
};

export enum PapiGqlInspectionStatus {
  All = 'ALL',
  AwaitingQc = 'AWAITING_QC',
  AwaitingRelease = 'AWAITING_RELEASE',
  Released = 'RELEASED'
}

export type PapiGqlInspectionTask = PapiGqlTask & {
  __typename?: 'InspectionTask';
  asset?: Maybe<PapiGqlTaskAsset>;
  author: PapiGqlAuthor;
  comments: Array<PapiGqlComment>;
  completedDate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'timestamp' instead */
  created: Scalars['String']['output'];
  createdBy?: Maybe<PapiGqlUser>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  hoursActual?: Maybe<Scalars['Float']['output']>;
  hoursEstimated?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  logs?: Maybe<Array<PapiGqlWorkLog>>;
  logSchema?: Maybe<Array<PapiGqlLogField>>;
  number?: Maybe<Scalars['Int']['output']>;
  permissions: PapiGqlPermissions;
  status: PapiGqlTaskStatus;
  steps?: Maybe<Array<PapiGqlTaskStep>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timestamp: Scalars['String']['output'];
  tower?: Maybe<PapiGqlTower>;
  turbine?: Maybe<PapiGqlTurbine>;
  type: PapiGqlTaskType;
  vendor?: Maybe<Scalars['String']['output']>;
  workOrder?: Maybe<PapiGqlWorkOrder>;
};

export type PapiGqlInspectionType = {
  __typename?: 'InspectionType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum PapiGqlInspectionTypeEnum {
  AutonomousDrone = 'AUTONOMOUS_DRONE',
  Ground = 'GROUND',
  Internal = 'INTERNAL',
  ManualDrone = 'MANUAL_DRONE',
  Rope = 'ROPE'
}

export type PapiGqlInspectionUpload = {
  __typename?: 'InspectionUpload';
  created: Scalars['String']['output'];
  createdBy?: Maybe<PapiGqlUser>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inspectionDate?: Maybe<Scalars['String']['output']>;
  mostRecentLog?: Maybe<PapiGqlInspectionUploadLog>;
  permissions: PapiGqlPermissions;
  processable: Scalars['Boolean']['output'];
  status?: Maybe<PapiGqlInspectionUploadStatus>;
  task?: Maybe<PapiGqlTask>;
  turbine?: Maybe<PapiGqlTurbine>;
  type?: Maybe<PapiGqlInspectionType>;
  uploadedImages?: Maybe<Array<Maybe<PapiGqlInspectionUploadImage>>>;
  vendor?: Maybe<PapiGqlVendor>;
};

export type PapiGqlInspectionUploadImage = {
  __typename?: 'InspectionUploadImage';
  assetDescriptors?: Maybe<Scalars['JSON']['output']>;
  blade?: Maybe<PapiGqlBlade>;
  /** @deprecated Use assetDescriptors instead */
  bladeDescriptors?: Maybe<Scalars['JSON']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  inspectionUpload: PapiGqlInspectionUpload;
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PapiGqlInspectionUploadLog = {
  __typename?: 'InspectionUploadLog';
  id: Scalars['ID']['output'];
  status: PapiGqlInspectionUploadStatus;
  timestamp: Scalars['String']['output'];
};

export enum PapiGqlInspectionUploadStatus {
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Succeeded = 'SUCCEEDED'
}

export type PapiGqlInspectTask = PapiGqlTask & {
  __typename?: 'InspectTask';
  asset?: Maybe<PapiGqlTaskAsset>;
  author: PapiGqlAuthor;
  comments: Array<PapiGqlComment>;
  completedDate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'timestamp' instead */
  created: Scalars['String']['output'];
  createdBy?: Maybe<PapiGqlUser>;
  damage?: Maybe<PapiGqlDamage>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  hoursActual?: Maybe<Scalars['Float']['output']>;
  hoursEstimated?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  logs?: Maybe<Array<PapiGqlWorkLog>>;
  logSchema?: Maybe<Array<PapiGqlLogField>>;
  number?: Maybe<Scalars['Int']['output']>;
  permissions: PapiGqlPermissions;
  status: PapiGqlTaskStatus;
  steps?: Maybe<Array<PapiGqlTaskStep>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timestamp: Scalars['String']['output'];
  tower?: Maybe<PapiGqlTower>;
  turbine?: Maybe<PapiGqlTurbine>;
  type: PapiGqlTaskType;
  vendor?: Maybe<Scalars['String']['output']>;
  workOrder?: Maybe<PapiGqlWorkOrder>;
};

export type PapiGqlInternalBladeInspectionTask = PapiGqlTask & {
  __typename?: 'InternalBladeInspectionTask';
  asset?: Maybe<PapiGqlTaskAsset>;
  author: PapiGqlAuthor;
  comments: Array<PapiGqlComment>;
  completedDate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'timestamp' instead */
  created: Scalars['String']['output'];
  createdBy?: Maybe<PapiGqlUser>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  hoursActual?: Maybe<Scalars['Float']['output']>;
  hoursEstimated?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  logs?: Maybe<Array<PapiGqlWorkLog>>;
  logSchema?: Maybe<Array<PapiGqlLogField>>;
  number?: Maybe<Scalars['Int']['output']>;
  permissions: PapiGqlPermissions;
  status: PapiGqlTaskStatus;
  steps?: Maybe<Array<PapiGqlTaskStep>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timestamp: Scalars['String']['output'];
  tower?: Maybe<PapiGqlTower>;
  turbine?: Maybe<PapiGqlTurbine>;
  type: PapiGqlTaskType;
  vendor?: Maybe<Scalars['String']['output']>;
  workOrder?: Maybe<PapiGqlWorkOrder>;
};

export type PapiGqlLatLongInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type PapiGqlList = {
  items?: Maybe<Array<Maybe<PapiGqlNode>>>;
  totalCount: Scalars['Int']['output'];
};

export type PapiGqlLocation = PapiGqlTaskAsset & {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Field no longer supported */
  locationCity?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  locationName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  locationSlug?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  locationState?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  locationZip?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  towers?: Maybe<Array<Maybe<PapiGqlTower>>>;
  turbines?: Maybe<Array<Maybe<PapiGqlTurbine>>>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type PapiGqlLogField = {
  __typename?: 'LogField';
  displayName: Scalars['String']['output'];
  formula?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  priority?: Maybe<Scalars['Int']['output']>;
  stats?: Maybe<PapiGqlLogStats>;
  type: PapiGqlLogFieldType;
};

export enum PapiGqlLogFieldType {
  Calculated = 'CALCULATED',
  Date = 'DATE',
  Multi = 'MULTI',
  Number = 'NUMBER',
  String = 'STRING',
  TimeRange = 'TIME_RANGE'
}

export type PapiGqlLogStats = {
  __typename?: 'LogStats';
  mean?: Maybe<Scalars['Boolean']['output']>;
  sum?: Maybe<Scalars['Boolean']['output']>;
};

export type PapiGqlLogStatsInput = {
  mean?: InputMaybe<Scalars['Boolean']['input']>;
  sum?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PapiGqlMaterialReference {
  AuxiliaryComponent = 'AUXILIARY_COMPONENT',
  Laminate = 'LAMINATE',
  Structure = 'STRUCTURE',
  Surface = 'SURFACE',
  Through = 'THROUGH',
  TopCoat = 'TOP_COAT'
}

export type PapiGqlMutation = {
  __typename?: 'Mutation';
  addAttachment?: Maybe<PapiGqlAttachment>;
  /** @deprecated Moved to atlas */
  addInspectionUploadImage: PapiGqlInspectionUploadImage;
  /** @deprecated Moved to atlas */
  addInspectionUploadImages: Array<PapiGqlInspectionUploadImage>;
  addTag?: Maybe<PapiGqlTag>;
  /** @deprecated Moved to atlas */
  bulkCreateInspections?: Maybe<Array<Maybe<PapiGqlInspection>>>;
  /** @deprecated Use atlas */
  copyWorkOrder?: Maybe<PapiGqlWorkOrder>;
  createComment: PapiGqlComment;
  /** @deprecated Moved to atlas */
  createInspection?: Maybe<PapiGqlInspection>;
  /** @deprecated Field no longer supported */
  createInspectionCampaign: PapiGqlInspectionCampaign;
  /** @deprecated Moved to atlas */
  createInspectionUpload: PapiGqlInspectionUpload;
  /** @deprecated Use atlas */
  createLogField: PapiGqlLogField;
  createNotification: PapiGqlNotification;
  /** @deprecated Use atlas */
  createTask?: Maybe<PapiGqlTask>;
  /** @deprecated Use atlas */
  createTasks?: Maybe<Array<Maybe<PapiGqlTask>>>;
  /** @deprecated Use atlas */
  createTaskSteps?: Maybe<Array<Maybe<PapiGqlTaskStep>>>;
  /** @deprecated Use atlas */
  createWorkCampaign?: Maybe<PapiGqlWorkCampaign>;
  /** @deprecated Use atlas */
  createWorkCampaigns?: Maybe<Array<Maybe<PapiGqlWorkCampaign>>>;
  /** @deprecated Use atlas */
  createWorkLogs: Array<PapiGqlWorkLog>;
  /** @deprecated Use atlas */
  createWorkOrder?: Maybe<PapiGqlWorkOrder>;
  /** @deprecated Use atlas */
  createWorkOrders?: Maybe<Array<Maybe<PapiGqlWorkOrder>>>;
  deleteAttachment?: Maybe<Scalars['Boolean']['output']>;
  deleteComment?: Maybe<PapiGqlComment>;
  /** @deprecated Moved to atlas */
  deleteInspection: Scalars['Boolean']['output'];
  /** @deprecated Moved to atlas */
  deleteInspectionUploadImages: Array<PapiGqlInspectionUploadImage>;
  /** @deprecated Moved to atlas */
  deleteInspectionUploads?: Maybe<PapiGqlDeleteInspectionUploadsPayload>;
  /** @deprecated Use atlas */
  deleteLogField: PapiGqlLogField;
  /** @deprecated Use atlas */
  deleteTask?: Maybe<PapiGqlTask>;
  /** @deprecated Use atlas */
  deleteTasks?: Maybe<Array<Maybe<PapiGqlTask>>>;
  /** @deprecated Use atlas */
  deleteTaskSteps?: Maybe<Array<Maybe<PapiGqlTaskStep>>>;
  /** @deprecated Use atlas */
  deleteWorkCampaign?: Maybe<PapiGqlWorkCampaign>;
  /** @deprecated Use atlas */
  deleteWorkCampaigns?: Maybe<Array<Maybe<PapiGqlWorkCampaign>>>;
  /** @deprecated Use atlas */
  deleteWorkLogs: Array<PapiGqlWorkLog>;
  /** @deprecated Use atlas */
  deleteWorkOrder?: Maybe<PapiGqlWorkOrder>;
  /** @deprecated Use atlas */
  deleteWorkOrders?: Maybe<Array<Maybe<PapiGqlWorkOrder>>>;
  editTower?: Maybe<PapiGqlTower>;
  editTurbine?: Maybe<PapiGqlTurbine>;
  notifyInspectionImageUploadError: PapiGqlNotification;
  notifyInspectionImageUploadSuccess: PapiGqlNotification;
  /** @deprecated Moved to atlas */
  processInspectionUpload: PapiGqlInspectionUploadLog;
  removeTag?: Maybe<PapiGqlTag>;
  setBladeSegmentations?: Maybe<PapiGqlPicture>;
  /** @deprecated Use atlas */
  setLogSchema?: Maybe<Array<PapiGqlLogField>>;
  /** @deprecated Use atlas */
  setTaskPriorityOrder?: Maybe<Array<Maybe<PapiGqlTask>>>;
  /** @deprecated Use atlas */
  setTaskStepPriorityOrder?: Maybe<Array<Maybe<PapiGqlTaskStep>>>;
  setTurbineStatus?: Maybe<PapiGqlTurbine>;
  /** @deprecated Use atlas */
  setWorkOrderPriorityOrder?: Maybe<Array<Maybe<PapiGqlWorkOrder>>>;
  updateAcknowledgement: Array<Maybe<PapiGqlAcknowledgement>>;
  updateAuxiliaryComponents: Array<Maybe<PapiGqlAuxiliaryComponent>>;
  updateComment: PapiGqlComment;
  /** @deprecated Moved to atlas */
  updateInspection?: Maybe<PapiGqlInspection>;
  /** @deprecated Field no longer supported */
  updateInspectionCampaign: PapiGqlInspectionCampaign;
  /** @deprecated Moved to atlas */
  updateInspections?: Maybe<Array<Maybe<PapiGqlInspection>>>;
  /** @deprecated Moved to atlas */
  updateInspectionUpload: PapiGqlInspectionUpload;
  /** @deprecated Moved to atlas */
  updateInspectionUploadImage: PapiGqlInspectionUploadImage;
  /** @deprecated Moved to atlas */
  updateInspectionUploadImages: Array<PapiGqlInspectionUploadImage>;
  /** @deprecated Use atlas */
  updateLogField: PapiGqlLogField;
  updateNotifications: Array<PapiGqlNotification>;
  /** @deprecated Use atlas */
  updateTask?: Maybe<PapiGqlTask>;
  /** @deprecated Use atlas */
  updateTasks?: Maybe<Array<Maybe<PapiGqlTask>>>;
  /** @deprecated Use atlas */
  updateTaskSteps?: Maybe<Array<Maybe<PapiGqlTaskStep>>>;
  /** @deprecated Use atlas */
  updateWorkCampaign?: Maybe<PapiGqlWorkCampaign>;
  /** @deprecated Use atlas */
  updateWorkCampaigns?: Maybe<Array<Maybe<PapiGqlWorkCampaign>>>;
  /** @deprecated Use atlas */
  updateWorkLogs: Array<PapiGqlWorkLog>;
  /** @deprecated Use atlas */
  updateWorkOrder?: Maybe<PapiGqlWorkOrder>;
  /** @deprecated Use atlas */
  updateWorkOrders?: Maybe<Array<Maybe<PapiGqlWorkOrder>>>;
};


export type PapiGqlMutationAddAttachmentArgs = {
  filename: Scalars['String']['input'];
  recordId: Scalars['ID']['input'];
};


export type PapiGqlMutationAddInspectionUploadImageArgs = {
  input: PapiGqlCreateInspectionUploadImageInput;
};


export type PapiGqlMutationAddInspectionUploadImagesArgs = {
  inputs: Array<PapiGqlCreateInspectionUploadImageInput>;
};


export type PapiGqlMutationAddTagArgs = {
  tagValue: Scalars['String']['input'];
};


export type PapiGqlMutationBulkCreateInspectionsArgs = {
  inspections: Array<InputMaybe<PapiGqlCreateInspectionInput>>;
};


export type PapiGqlMutationCopyWorkOrderArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlMutationCreateCommentArgs = {
  input: PapiGqlCreateCommentInput;
};


export type PapiGqlMutationCreateInspectionArgs = {
  inspection: PapiGqlCreateInspectionInput;
};


export type PapiGqlMutationCreateInspectionCampaignArgs = {
  input: PapiGqlCreateInspectionCampaignInput;
};


export type PapiGqlMutationCreateInspectionUploadArgs = {
  input: PapiGqlCreateInspectionUploadInput;
};


export type PapiGqlMutationCreateLogFieldArgs = {
  logField: PapiGqlCreateLogFieldInput;
};


export type PapiGqlMutationCreateNotificationArgs = {
  input?: InputMaybe<PapiGqlCreateNotificationInput>;
};


export type PapiGqlMutationCreateTaskArgs = {
  input: PapiGqlTaskCreateInput;
};


export type PapiGqlMutationCreateTasksArgs = {
  inputs: Array<InputMaybe<PapiGqlTaskCreateInput>>;
};


export type PapiGqlMutationCreateTaskStepsArgs = {
  inputs: Array<PapiGqlTaskStepCreateInput>;
};


export type PapiGqlMutationCreateWorkCampaignArgs = {
  input: PapiGqlWorkCampaignCreateInput;
};


export type PapiGqlMutationCreateWorkCampaignsArgs = {
  inputs: Array<PapiGqlWorkCampaignCreateInput>;
};


export type PapiGqlMutationCreateWorkLogsArgs = {
  inputs: Array<PapiGqlCreateWorkLogInput>;
};


export type PapiGqlMutationCreateWorkOrderArgs = {
  input: PapiGqlWorkOrderCreateInput;
};


export type PapiGqlMutationCreateWorkOrdersArgs = {
  inputs: Array<PapiGqlWorkOrderCreateInput>;
};


export type PapiGqlMutationDeleteAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlMutationDeleteCommentArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlMutationDeleteInspectionArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlMutationDeleteInspectionUploadImagesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type PapiGqlMutationDeleteInspectionUploadsArgs = {
  input: PapiGqlDeleteInspectionUploadsInput;
};


export type PapiGqlMutationDeleteLogFieldArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlMutationDeleteTaskArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlMutationDeleteTasksArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type PapiGqlMutationDeleteTaskStepsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type PapiGqlMutationDeleteWorkCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlMutationDeleteWorkCampaignsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type PapiGqlMutationDeleteWorkLogsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type PapiGqlMutationDeleteWorkOrderArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlMutationDeleteWorkOrdersArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type PapiGqlMutationEditTowerArgs = {
  id: Scalars['ID']['input'];
  input: PapiGqlTowerInput;
};


export type PapiGqlMutationEditTurbineArgs = {
  id: Scalars['ID']['input'];
  input: PapiGqlTurbineInput;
};


export type PapiGqlMutationNotifyInspectionImageUploadErrorArgs = {
  input?: InputMaybe<PapiGqlNotifyInspectionImageUploadInput>;
};


export type PapiGqlMutationNotifyInspectionImageUploadSuccessArgs = {
  input?: InputMaybe<PapiGqlNotifyInspectionImageUploadInput>;
};


export type PapiGqlMutationProcessInspectionUploadArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlMutationRemoveTagArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlMutationSetBladeSegmentationsArgs = {
  segsInput: PapiGqlSegmentationsInput;
};


export type PapiGqlMutationSetLogSchemaArgs = {
  fieldIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<PapiGqlTaskType>;
};


export type PapiGqlMutationSetTaskPriorityOrderArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type PapiGqlMutationSetTaskStepPriorityOrderArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type PapiGqlMutationSetTurbineStatusArgs = {
  id: Scalars['ID']['input'];
  status: PapiGqlTurbineStatus;
};


export type PapiGqlMutationSetWorkOrderPriorityOrderArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type PapiGqlMutationUpdateAcknowledgementArgs = {
  inputs: PapiGqlUpdateAcknowledgementInput;
};


export type PapiGqlMutationUpdateAuxiliaryComponentsArgs = {
  components: Array<InputMaybe<PapiGqlAuxiliaryComponent>>;
  turbineId: Scalars['ID']['input'];
};


export type PapiGqlMutationUpdateCommentArgs = {
  input: PapiGqlUpdateCommentInput;
};


export type PapiGqlMutationUpdateInspectionArgs = {
  inspection: PapiGqlInspectionInput;
};


export type PapiGqlMutationUpdateInspectionCampaignArgs = {
  input: PapiGqlUpdateInspectionCampaignInput;
};


export type PapiGqlMutationUpdateInspectionsArgs = {
  inspections: Array<InputMaybe<PapiGqlInspectionInput>>;
};


export type PapiGqlMutationUpdateInspectionUploadArgs = {
  input: PapiGqlUpdateInspectionUploadInput;
};


export type PapiGqlMutationUpdateInspectionUploadImageArgs = {
  input: PapiGqlUpdateInspectionUploadImageInput;
};


export type PapiGqlMutationUpdateInspectionUploadImagesArgs = {
  inputs?: InputMaybe<Array<PapiGqlUpdateInspectionUploadImageInput>>;
};


export type PapiGqlMutationUpdateLogFieldArgs = {
  logField: PapiGqlUpdateLogFieldInput;
};


export type PapiGqlMutationUpdateNotificationsArgs = {
  inputs: Array<PapiGqlUpdateNotificationInput>;
};


export type PapiGqlMutationUpdateTaskArgs = {
  id: Scalars['ID']['input'];
  input: PapiGqlTaskUpdateInput;
};


export type PapiGqlMutationUpdateTasksArgs = {
  ids: Array<Scalars['ID']['input']>;
  input: PapiGqlTaskUpdateInput;
};


export type PapiGqlMutationUpdateTaskStepsArgs = {
  inputs: Array<PapiGqlTaskStepUpdateInput>;
};


export type PapiGqlMutationUpdateWorkCampaignArgs = {
  id: Scalars['ID']['input'];
  input: PapiGqlWorkCampaignUpdateInput;
};


export type PapiGqlMutationUpdateWorkCampaignsArgs = {
  ids: Array<Scalars['ID']['input']>;
  input: PapiGqlWorkCampaignUpdateInput;
};


export type PapiGqlMutationUpdateWorkLogsArgs = {
  inputs: Array<PapiGqlUpdateWorkLogInput>;
};


export type PapiGqlMutationUpdateWorkOrderArgs = {
  id: Scalars['ID']['input'];
  input: PapiGqlWorkOrderUpdateInput;
};


export type PapiGqlMutationUpdateWorkOrdersArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  input: PapiGqlWorkOrderUpdateInput;
};

export type PapiGqlNode = {
  id: Scalars['ID']['output'];
};

export type PapiGqlNotification = {
  __typename?: 'Notification';
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  type: PapiGqlNotificationType;
};

export enum PapiGqlNotificationType {
  Error = 'ERROR',
  Info = 'INFO',
  Success = 'SUCCESS'
}

export type PapiGqlNotifyInspectionImageUploadInput = {
  inspectionId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

export type PapiGqlObservation = {
  blade: PapiGqlBlade;
  customerId: Scalars['ID']['output'];
  damages?: Maybe<Array<Maybe<PapiGqlDamage>>>;
  id: Scalars['ID']['output'];
  type: PapiGqlObservationType;
};

export enum PapiGqlObservationType {
  Annotation = 'ANNOTATION'
}

export type PapiGqlOtherTask = PapiGqlTask & {
  __typename?: 'OtherTask';
  asset?: Maybe<PapiGqlTaskAsset>;
  author: PapiGqlAuthor;
  comments: Array<PapiGqlComment>;
  completedDate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'timestamp' instead */
  created: Scalars['String']['output'];
  createdBy?: Maybe<PapiGqlUser>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  hoursActual?: Maybe<Scalars['Float']['output']>;
  hoursEstimated?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  logs?: Maybe<Array<PapiGqlWorkLog>>;
  logSchema?: Maybe<Array<PapiGqlLogField>>;
  number?: Maybe<Scalars['Int']['output']>;
  permissions: PapiGqlPermissions;
  status: PapiGqlTaskStatus;
  steps?: Maybe<Array<PapiGqlTaskStep>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timestamp: Scalars['String']['output'];
  tower?: Maybe<PapiGqlTower>;
  turbine?: Maybe<PapiGqlTurbine>;
  type: PapiGqlTaskType;
  vendor?: Maybe<Scalars['String']['output']>;
  workOrder?: Maybe<PapiGqlWorkOrder>;
};

export type PapiGqlPermissions = {
  __typename?: 'Permissions';
  canDelete: Scalars['Boolean']['output'];
  canUpdate: Scalars['Boolean']['output'];
};

export type PapiGqlPhotogenic = {
  picture?: Maybe<PapiGqlPicture>;
};

export type PapiGqlPicture = {
  __typename?: 'Picture';
  adjacentPictures?: Maybe<PapiGqlAdjacentPictures>;
  /** @deprecated use 'damages' instead */
  annotations?: Maybe<Array<Maybe<PapiGqlAnnotation>>>;
  blade?: Maybe<PapiGqlBlade>;
  bladeAngle?: Maybe<Scalars['String']['output']>;
  bladeChamber?: Maybe<Scalars['String']['output']>;
  bladeSegmentations?: Maybe<Array<Maybe<PapiGqlPolygon>>>;
  bladeSide?: Maybe<Scalars['String']['output']>;
  cameraType?: Maybe<Scalars['String']['output']>;
  /** @deprecated no longer necessary */
  customerSlug?: Maybe<Scalars['String']['output']>;
  damages?: Maybe<Array<Maybe<PapiGqlDamage>>>;
  droneIdLogId?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  globalId?: Maybe<Scalars['ID']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  homography?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<PapiGqlImage>;
  imageHeight?: Maybe<Scalars['Int']['output']>;
  imageName?: Maybe<Scalars['String']['output']>;
  imageWidth?: Maybe<Scalars['Int']['output']>;
  inspection?: Maybe<PapiGqlInspection>;
  inspectionDate?: Maybe<Scalars['String']['output']>;
  inspectionTime?: Maybe<Scalars['String']['output']>;
  intrinsicMatrix?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  location?: Maybe<PapiGqlLocation>;
  navCommand?: Maybe<Scalars['String']['output']>;
  observations?: Maybe<Array<Maybe<PapiGqlObservation>>>;
  observationTimestamp?: Maybe<Scalars['Date']['output']>;
  radialDistance?: Maybe<Scalars['Float']['output']>;
  rbtBladeToGround?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  rbtCameraToGround?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  rbtPlaneToGround?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  reviewed?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<PapiGqlPictureSource>;
  /** @deprecated use 'source' */
  sourceType?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  /** @deprecated use 'image.dziSchema' for tiling information */
  tileSize?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  tower?: Maybe<PapiGqlTower>;
  towerSide?: Maybe<Scalars['String']['output']>;
  transitionPieceSide?: Maybe<Scalars['String']['output']>;
  turbine?: Maybe<PapiGqlTurbine>;
  url?: Maybe<Scalars['String']['output']>;
};


export type PapiGqlPictureImageArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};

export type PapiGqlPictureSource = {
  __typename?: 'PictureSource';
  description: Scalars['String']['output'];
  id: PapiGqlPictureSourceType;
  label: Scalars['String']['output'];
};

export enum PapiGqlPictureSourceType {
  BulkIngest = 'BULK_INGEST',
  SkyspecsDrone = 'SKYSPECS_DRONE'
}

export type PapiGqlPolygon = {
  __typename?: 'Polygon';
  points?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
};

export type PapiGqlPolygonInput = {
  points?: InputMaybe<Array<InputMaybe<Array<Scalars['Float']['input']>>>>;
};

export type PapiGqlQuery = {
  __typename?: 'Query';
  acknowledgementsByUser: Array<Maybe<PapiGqlAcknowledgement>>;
  annotations?: Maybe<PapiGqlAnnotationsResponseObject>;
  attachments?: Maybe<Array<Maybe<PapiGqlAttachment>>>;
  auxiliaryComponents?: Maybe<Array<Maybe<PapiGqlAuxiliaryComponentNode>>>;
  blade?: Maybe<PapiGqlBlade>;
  bladeChambers: Array<PapiGqlBladeChamberValue>;
  blades?: Maybe<Array<Maybe<PapiGqlBlade>>>;
  bladeSides: Array<PapiGqlBladeSideValue>;
  comments: Array<PapiGqlComment>;
  customers: Array<PapiGqlCustomer>;
  damage?: Maybe<PapiGqlDamage>;
  damages?: Maybe<PapiGqlDamageList>;
  featureFlags?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated Use 'featureFlags' instead */
  features?: Maybe<PapiGqlFeatureList>;
  imageFilters?: Maybe<Array<Maybe<PapiGqlImageFilter>>>;
  /** @deprecated Moved to atlas */
  inspection?: Maybe<PapiGqlInspection>;
  /** @deprecated Moved to atlas */
  inspectionByTaskId?: Maybe<PapiGqlInspection>;
  /** @deprecated Field no longer supported */
  inspectionCampaign?: Maybe<PapiGqlInspectionCampaign>;
  /** @deprecated Field no longer supported */
  inspectionCampaigns?: Maybe<Array<PapiGqlInspectionCampaign>>;
  /** @deprecated Moved to atlas */
  inspectionListFilters: PapiGqlInspectionListFilters;
  /** @deprecated Moved to atlas */
  inspections?: Maybe<Array<Maybe<PapiGqlInspection>>>;
  /** @deprecated Moved to atlas */
  inspectionTypes?: Maybe<Array<PapiGqlInspectionType>>;
  /** @deprecated Moved to atlas */
  inspectionUpload?: Maybe<PapiGqlInspectionUpload>;
  /** @deprecated Moved to atlas */
  inspectionUploadByTaskId?: Maybe<PapiGqlInspectionUpload>;
  /** @deprecated Moved to atlas */
  inspectionUploads?: Maybe<Array<PapiGqlInspectionUpload>>;
  /** @deprecated Moved to atlas */
  inspectionVendors?: Maybe<Array<PapiGqlVendor>>;
  location?: Maybe<PapiGqlLocation>;
  locations?: Maybe<Array<Maybe<PapiGqlLocation>>>;
  logFields?: Maybe<Array<PapiGqlLogField>>;
  logSchema?: Maybe<Array<PapiGqlLogField>>;
  notifications: Array<PapiGqlNotification>;
  observation?: Maybe<PapiGqlObservation>;
  observations?: Maybe<Array<Maybe<PapiGqlObservation>>>;
  paginatedBlades?: Maybe<PapiGqlBladeList>;
  /** @deprecated Moved to atlas */
  paginatedInspections?: Maybe<PapiGqlInspectionList>;
  paginatedTasks?: Maybe<PapiGqlTaskList>;
  paginatedTurbines?: Maybe<PapiGqlTurbineList>;
  paginatedWorkOrders?: Maybe<PapiGqlWorkOrderList>;
  picture?: Maybe<PapiGqlPicture>;
  pictures?: Maybe<Array<Maybe<PapiGqlPicture>>>;
  pictureSources?: Maybe<Array<PapiGqlPictureSource>>;
  sortedPictures?: Maybe<Array<Maybe<PapiGqlPicture>>>;
  tags?: Maybe<Array<PapiGqlTag>>;
  task?: Maybe<PapiGqlTask>;
  taskAsset?: Maybe<PapiGqlTaskAsset>;
  tasks?: Maybe<Array<Maybe<PapiGqlTask>>>;
  /** @deprecated Use atlas */
  taskStep?: Maybe<PapiGqlTaskStep>;
  tower?: Maybe<PapiGqlTower>;
  towers?: Maybe<Array<Maybe<PapiGqlTower>>>;
  turbine?: Maybe<PapiGqlTurbine>;
  turbines?: Maybe<Array<Maybe<PapiGqlTurbine>>>;
  unplannedTasks?: Maybe<Array<Maybe<PapiGqlTask>>>;
  unplannedWorkOrders?: Maybe<Array<PapiGqlWorkOrder>>;
  user?: Maybe<PapiGqlUser>;
  users: Array<PapiGqlUser>;
  workCampaign?: Maybe<PapiGqlWorkCampaign>;
  workCampaigns?: Maybe<Array<PapiGqlWorkCampaign>>;
  workLog?: Maybe<PapiGqlWorkLog>;
  workLogs?: Maybe<Array<PapiGqlWorkLog>>;
  workOrder?: Maybe<PapiGqlWorkOrder>;
  workOrders?: Maybe<Array<PapiGqlWorkOrder>>;
};


export type PapiGqlQueryAcknowledgementsByUserArgs = {
  acknowledgementType?: InputMaybe<PapiGqlAcknowledgementType>;
};


export type PapiGqlQueryAnnotationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  damageDepth?: InputMaybe<Scalars['String']['input']>;
  damageType?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isNewest?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  severityModifier?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tower?: InputMaybe<Scalars['String']['input']>;
};


export type PapiGqlQueryAttachmentsArgs = {
  recordId: Scalars['ID']['input'];
};


export type PapiGqlQueryBladeArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlQueryBladesArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  turbineIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type PapiGqlQueryCommentsArgs = {
  threadId: Scalars['ID']['input'];
};


export type PapiGqlQueryDamageArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlQueryDamagesArgs = {
  critical?: InputMaybe<Scalars['Boolean']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<Array<InputMaybe<PapiGqlFilterBy>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  locations?: InputMaybe<Array<Scalars['ID']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  recent?: InputMaybe<Scalars['Boolean']['input']>;
  schema?: InputMaybe<Scalars['ID']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<PapiGqlSortBy>>>;
  tower?: InputMaybe<Scalars['ID']['input']>;
  towers?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type PapiGqlQueryInspectionArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlQueryInspectionByTaskIdArgs = {
  taskId: Scalars['ID']['input'];
};


export type PapiGqlQueryInspectionCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlQueryInspectionsArgs = {
  status?: InputMaybe<Array<InputMaybe<PapiGqlInspectionStatus>>>;
};


export type PapiGqlQueryInspectionUploadArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlQueryInspectionUploadByTaskIdArgs = {
  taskId: Scalars['ID']['input'];
};


export type PapiGqlQueryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlQueryLogSchemaArgs = {
  type?: InputMaybe<PapiGqlTaskType>;
};


export type PapiGqlQueryObservationArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlQueryObservationsArgs = {
  global_id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  observation_id?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  picture_id?: InputMaybe<Scalars['ID']['input']>;
};


export type PapiGqlQueryPaginatedBladesArgs = {
  filterBy?: InputMaybe<Array<InputMaybe<PapiGqlFilterBy>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<PapiGqlSortBy>>>;
};


export type PapiGqlQueryPaginatedInspectionsArgs = {
  filterBy?: InputMaybe<Array<InputMaybe<PapiGqlFilterBy>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<PapiGqlSortBy>>>;
};


export type PapiGqlQueryPaginatedTasksArgs = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterBy?: InputMaybe<Array<InputMaybe<PapiGqlFilterBy>>>;
  fuzzySearch?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<PapiGqlSortBy>>>;
};


export type PapiGqlQueryPaginatedTurbinesArgs = {
  filterBy?: InputMaybe<Array<InputMaybe<PapiGqlFilterBy>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<PapiGqlSortBy>>>;
};


export type PapiGqlQueryPaginatedWorkOrdersArgs = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filterBy?: InputMaybe<Array<InputMaybe<PapiGqlFilterBy>>>;
  fuzzySearch?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Array<InputMaybe<PapiGqlSortBy>>>;
};


export type PapiGqlQueryPictureArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlQueryPicturesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type PapiGqlQuerySortedPicturesArgs = {
  lastId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type PapiGqlQueryTaskArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlQueryTaskAssetArgs = {
  taskId: Scalars['ID']['input'];
};


export type PapiGqlQueryTasksArgs = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type PapiGqlQueryTaskStepArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlQueryTowerArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlQueryTowersArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type PapiGqlQueryTurbineArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlQueryTurbinesArgs = {
  distance?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  latLng?: InputMaybe<Array<Scalars['Float']['input']>>;
};


export type PapiGqlQueryUnplannedTasksArgs = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type PapiGqlQueryUnplannedWorkOrdersArgs = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type PapiGqlQueryUsersArgs = {
  onlyCollaborators?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PapiGqlQueryWorkCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlQueryWorkCampaignsArgs = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type PapiGqlQueryWorkLogArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlQueryWorkLogsArgs = {
  taskId: Scalars['ID']['input'];
};


export type PapiGqlQueryWorkOrderArgs = {
  id: Scalars['ID']['input'];
};


export type PapiGqlQueryWorkOrdersArgs = {
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PapiGqlRepairTask = PapiGqlTask & {
  __typename?: 'RepairTask';
  /** @deprecated Use 'damage' instead */
  annotation?: Maybe<PapiGqlAnnotation>;
  asset?: Maybe<PapiGqlTaskAsset>;
  author: PapiGqlAuthor;
  comments: Array<PapiGqlComment>;
  completedDate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'timestamp' instead */
  created: Scalars['String']['output'];
  createdBy?: Maybe<PapiGqlUser>;
  damage?: Maybe<PapiGqlDamage>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  hoursActual?: Maybe<Scalars['Float']['output']>;
  hoursEstimated?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  logs?: Maybe<Array<PapiGqlWorkLog>>;
  logSchema?: Maybe<Array<PapiGqlLogField>>;
  number?: Maybe<Scalars['Int']['output']>;
  permissions: PapiGqlPermissions;
  status: PapiGqlTaskStatus;
  steps?: Maybe<Array<PapiGqlTaskStep>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timestamp: Scalars['String']['output'];
  tower?: Maybe<PapiGqlTower>;
  turbine?: Maybe<PapiGqlTurbine>;
  type: PapiGqlTaskType;
  vendor?: Maybe<Scalars['String']['output']>;
  workOrder?: Maybe<PapiGqlWorkOrder>;
};

export type PapiGqlRole = {
  __typename?: 'Role';
  actions: Array<Maybe<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type PapiGqlSegmentationsInput = {
  id: Scalars['ID']['input'];
  segs?: InputMaybe<Array<InputMaybe<PapiGqlPolygonInput>>>;
};

export type PapiGqlSortBy = {
  key: Scalars['String']['input'];
  sort?: InputMaybe<PapiGqlSortDirection>;
};

export enum PapiGqlSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PapiGqlTag = {
  __typename?: 'Tag';
  id: Scalars['ID']['output'];
  tag?: Maybe<Scalars['String']['output']>;
};

export type PapiGqlTask = {
  asset?: Maybe<PapiGqlTaskAsset>;
  author: PapiGqlAuthor;
  comments: Array<PapiGqlComment>;
  completedDate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'timestamp' instead */
  created: Scalars['String']['output'];
  /** @deprecated Use 'user' instead */
  createdBy?: Maybe<PapiGqlUser>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  hoursActual?: Maybe<Scalars['Float']['output']>;
  hoursEstimated?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  logs?: Maybe<Array<PapiGqlWorkLog>>;
  logSchema?: Maybe<Array<PapiGqlLogField>>;
  number?: Maybe<Scalars['Int']['output']>;
  permissions: PapiGqlPermissions;
  status: PapiGqlTaskStatus;
  steps?: Maybe<Array<PapiGqlTaskStep>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timestamp: Scalars['String']['output'];
  /** @deprecated Use 'asset' instead */
  tower?: Maybe<PapiGqlTower>;
  /** @deprecated Use 'asset' instead */
  turbine?: Maybe<PapiGqlTurbine>;
  type: PapiGqlTaskType;
  vendor?: Maybe<Scalars['String']['output']>;
  workOrder?: Maybe<PapiGqlWorkOrder>;
};

export type PapiGqlTaskAsset = {
  id: Scalars['ID']['output'];
};

export enum PapiGqlTaskAssetType {
  Blade = 'BLADE',
  Site = 'SITE',
  Turbine = 'TURBINE'
}

export type PapiGqlTaskCreateInput = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  damageId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  hoursActual?: InputMaybe<Scalars['Float']['input']>;
  hoursEstimated?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<PapiGqlTaskStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  towerId?: InputMaybe<Scalars['ID']['input']>;
  type: PapiGqlTaskType;
  vendor?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type PapiGqlTaskList = {
  __typename?: 'TaskList';
  items?: Maybe<Array<Maybe<PapiGqlTask>>>;
  totalCount: Scalars['Int']['output'];
};

export type PapiGqlTaskLogged = {
  __typename?: 'TaskLogged';
  asset?: Maybe<PapiGqlTaskAsset>;
  id: Scalars['ID']['output'];
  number?: Maybe<Scalars['Int']['output']>;
  type: PapiGqlTaskType;
};

export enum PapiGqlTaskStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type PapiGqlTaskStep = {
  __typename?: 'TaskStep';
  author: PapiGqlAuthor;
  comments: Array<PapiGqlComment>;
  completed: Scalars['Boolean']['output'];
  dataEntry?: Maybe<Scalars['JSON']['output']>;
  dataSchema?: Maybe<Array<Maybe<PapiGqlLogField>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: PapiGqlPermissions;
  priority?: Maybe<Scalars['Int']['output']>;
  timestamp: Scalars['String']['output'];
};

export type PapiGqlTaskStepCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
};

export type PapiGqlTaskStepUpdateInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  dataEntry?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum PapiGqlTaskType {
  Inspect = 'INSPECT',
  Inspection = 'INSPECTION',
  InternalBladeInspection = 'INTERNAL_BLADE_INSPECTION',
  Other = 'OTHER',
  Repair = 'REPAIR',
  WorkCampaign = 'WORK_CAMPAIGN',
  WorkOrder = 'WORK_ORDER'
}

export type PapiGqlTaskUpdateInput = {
  completedDate?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  hoursActual?: InputMaybe<Scalars['Float']['input']>;
  hoursEstimated?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<PapiGqlTaskStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  vendor?: InputMaybe<Scalars['String']['input']>;
  workOrderId?: InputMaybe<Scalars['ID']['input']>;
};

export type PapiGqlTower = {
  __typename?: 'Tower';
  /** @deprecated Use 'blade.length' instead */
  bladeLength?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'blade.manufacturer' instead */
  bladeManufacturer?: Maybe<Scalars['String']['output']>;
  blades?: Maybe<Array<Maybe<PapiGqlBlade>>>;
  dateTimeCreated?: Maybe<Scalars['String']['output']>;
  dateTimeModified?: Maybe<Scalars['String']['output']>;
  hubHeight?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inspections?: Maybe<Array<Maybe<PapiGqlInspection>>>;
  latestInspection?: Maybe<PapiGqlInspection>;
  latitude?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<PapiGqlLocation>;
  longitude?: Maybe<Scalars['Float']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rotorDiameter?: Maybe<Scalars['String']['output']>;
  serial?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PapiGqlTurbineStatus>;
  tasks?: Maybe<Array<Maybe<PapiGqlTask>>>;
  /** @deprecated Use 'manufacturer' instead */
  towerManufacturer?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'model' instead */
  towerModel?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'name' instead */
  towerNumber?: Maybe<Scalars['String']['output']>;
  turbine?: Maybe<PapiGqlTurbine>;
  yearOnline?: Maybe<Scalars['String']['output']>;
};


export type PapiGqlTowerInspectionsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type PapiGqlTowerInput = {
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export type PapiGqlTurbine = PapiGqlNode & PapiGqlTaskAsset & {
  __typename?: 'Turbine';
  auxiliaryComponents: Array<Maybe<PapiGqlAuxiliaryComponent>>;
  blades?: Maybe<Array<Maybe<PapiGqlBlade>>>;
  customer?: Maybe<PapiGqlCustomer>;
  damages?: Maybe<Array<Maybe<PapiGqlDamage>>>;
  distance?: Maybe<Scalars['String']['output']>;
  hasSkySpecsInspections?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  inspections?: Maybe<Array<Maybe<PapiGqlInspection>>>;
  latLng?: Maybe<Array<Scalars['Float']['output']>>;
  location?: Maybe<PapiGqlLocation>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serial?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PapiGqlTurbineStatus>;
  tasks?: Maybe<Array<Maybe<PapiGqlTask>>>;
};


export type PapiGqlTurbineInspectionsArgs = {
  status?: InputMaybe<Array<InputMaybe<PapiGqlInspectionStatus>>>;
};

export type PapiGqlTurbineInput = {
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export type PapiGqlTurbineList = PapiGqlList & {
  __typename?: 'TurbineList';
  items?: Maybe<Array<Maybe<PapiGqlTurbine>>>;
  totalCount: Scalars['Int']['output'];
};

export enum PapiGqlTurbineStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type PapiGqlUpdateAcknowledgementInput = {
  accept: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type PapiGqlUpdateCommentInput = {
  comment: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type PapiGqlUpdateInspectionCampaignInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type PapiGqlUpdateInspectionUploadImageInput = {
  assetDescriptors?: InputMaybe<Scalars['JSON']['input']>;
  bladeDescriptors?: InputMaybe<Scalars['JSON']['input']>;
  bladeId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type PapiGqlUpdateInspectionUploadInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  inspectionDate?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
  turbineId?: InputMaybe<Scalars['ID']['input']>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type PapiGqlUpdateLogFieldInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  formula?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stats?: InputMaybe<PapiGqlLogStatsInput>;
};

export type PapiGqlUpdateNotificationInput = {
  id: Scalars['ID']['input'];
  isRead: Scalars['Boolean']['input'];
};

export type PapiGqlUpdateWorkLogInput = {
  entry?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type PapiGqlUser = {
  __typename?: 'User';
  created: Scalars['String']['output'];
  customer?: Maybe<PapiGqlCustomer>;
  customers?: Maybe<Array<PapiGqlCustomer>>;
  email: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  roles: Array<Maybe<PapiGqlRole>>;
  status: Scalars['String']['output'];
};

export type PapiGqlVendor = {
  __typename?: 'Vendor';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PapiGqlWorkCampaign = {
  __typename?: 'WorkCampaign';
  asset?: Maybe<PapiGqlTaskAsset>;
  author: PapiGqlAuthor;
  completedDate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'timestamp' instead */
  created: Scalars['String']['output'];
  /** @deprecated Use 'user' instead */
  createdBy?: Maybe<PapiGqlUser>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  hoursActual?: Maybe<Scalars['Float']['output']>;
  hoursEstimated?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  logs?: Maybe<Array<PapiGqlWorkLog>>;
  logSchema?: Maybe<Array<PapiGqlLogField>>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  permissions: PapiGqlPermissions;
  status: PapiGqlTaskStatus;
  timestamp: Scalars['String']['output'];
  workOrders?: Maybe<Array<Maybe<PapiGqlWorkOrder>>>;
};


export type PapiGqlWorkCampaignWorkOrdersArgs = {
  sortBy?: InputMaybe<Array<InputMaybe<PapiGqlSortBy>>>;
};

export type PapiGqlWorkCampaignCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  hoursActual?: InputMaybe<Scalars['Float']['input']>;
  hoursEstimated?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<PapiGqlTaskStatus>;
  workOrderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PapiGqlWorkCampaignUpdateInput = {
  completedDate?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  hoursActual?: InputMaybe<Scalars['Float']['input']>;
  hoursEstimated?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PapiGqlTaskStatus>;
};

export type PapiGqlWorkLog = {
  __typename?: 'WorkLog';
  author: PapiGqlAuthor;
  date: Scalars['String']['output'];
  entry?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  permissions: PapiGqlPermissions;
  task: PapiGqlTaskLogged;
  timestamp: Scalars['String']['output'];
};

export type PapiGqlWorkOrder = PapiGqlNode & {
  __typename?: 'WorkOrder';
  asset?: Maybe<PapiGqlTaskAsset>;
  author: PapiGqlAuthor;
  /** @deprecated Use 'collaboratorUsers' instead */
  collaborators?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  collaboratorUsers?: Maybe<Array<Maybe<PapiGqlUser>>>;
  completedDate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'timestamp' instead */
  created: Scalars['String']['output'];
  /** @deprecated Use 'user' instead */
  createdBy?: Maybe<PapiGqlUser>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  hoursActual?: Maybe<Scalars['Float']['output']>;
  hoursEstimated?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  logs?: Maybe<Array<PapiGqlWorkLog>>;
  logSchema?: Maybe<Array<PapiGqlLogField>>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  permissions: PapiGqlPermissions;
  status: PapiGqlTaskStatus;
  tasks?: Maybe<Array<Maybe<PapiGqlTask>>>;
  timestamp: Scalars['String']['output'];
  workCampaign?: Maybe<PapiGqlWorkCampaign>;
};


export type PapiGqlWorkOrderTasksArgs = {
  sortBy?: InputMaybe<Array<InputMaybe<PapiGqlSortBy>>>;
};

export type PapiGqlWorkOrderCreateInput = {
  collaborators?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  hoursActual?: InputMaybe<Scalars['Float']['input']>;
  hoursEstimated?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PapiGqlTaskStatus>;
  tasks?: InputMaybe<Array<PapiGqlTaskCreateInput>>;
};

export type PapiGqlWorkOrderList = PapiGqlList & {
  __typename?: 'WorkOrderList';
  items?: Maybe<Array<Maybe<PapiGqlWorkOrder>>>;
  totalCount: Scalars['Int']['output'];
};

export type PapiGqlWorkOrderUpdateInput = {
  collaborators?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  completedDate?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  hoursActual?: InputMaybe<Scalars['Float']['input']>;
  hoursEstimated?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PapiGqlTaskStatus>;
  workCampaignId?: InputMaybe<Scalars['ID']['input']>;
};

export type PapiGqlCreateTaskStepsMutationVariables = Exact<{
  inputs: Array<PapiGqlTaskStepCreateInput> | PapiGqlTaskStepCreateInput;
}>;


export type PapiGqlCreateTaskStepsMutation = { __typename?: 'Mutation', createTaskSteps?: Array<{ __typename?: 'TaskStep', id: string, name: string, description?: string | null } | null> | null };

export type PapiGqlFleetMapQueryVariables = Exact<{ [key: string]: never; }>;


export type PapiGqlFleetMapQuery = { __typename?: 'Query', turbines?: Array<{ __typename?: 'Turbine', id: string, name?: string | null, latLng?: Array<number> | null, status?: PapiGqlTurbineStatus | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null> | null };

export type PapiGqlGetFullscreenImageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeHorizonDamage?: Scalars['Boolean']['input'];
}>;


export type PapiGqlGetFullscreenImageQuery = { __typename?: 'Query', picture?: { __typename?: 'Picture', blade?: { __typename?: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, make?: string | null, model?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | null, damages?: Array<{ __typename?: 'Damage', id: string, number?: string | null, tasks?: Array<{ __typename?: 'InspectionTask', id: string } | { __typename?: 'InspectTask', id: string } | { __typename?: 'InternalBladeInspectionTask', id: string } | { __typename?: 'OtherTask', id: string } | { __typename?: 'RepairTask', id: string } | null> | null, observations?: Array<{ __typename?: 'AnnotationObservation', coordinates?: Array<Array<number | null> | null> | null, descriptors?: Array<string | null> | null, annotationType?: PapiGqlAnnotationTypeReference | null, bladeSide?: string | null, id: string } | null> | null } | null> | null } | null };

export type PapiGqlAddAttachmentMutationVariables = Exact<{
  filename: Scalars['String']['input'];
  recordId: Scalars['ID']['input'];
}>;


export type PapiGqlAddAttachmentMutation = { __typename?: 'Mutation', addAttachment?: { __typename?: 'Attachment', id: string, s3Key: string } | null };

export type PapiGqlDeleteAttachmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PapiGqlDeleteAttachmentMutation = { __typename?: 'Mutation', deleteAttachment?: boolean | null };

export type PapiGqlCreateCommentMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
}>;


export type PapiGqlCreateCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'Comment', id: string, comment: string } };

export type PapiGqlDeleteCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PapiGqlDeleteCommentMutation = { __typename?: 'Mutation', deleteComment?: { __typename?: 'Comment', id: string } | null };

export type PapiGqlUpdateCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
}>;


export type PapiGqlUpdateCommentMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'Comment', id: string } };

export type PapiGqlGetCommentsQueryVariables = Exact<{
  threadId: Scalars['ID']['input'];
}>;


export type PapiGqlGetCommentsQuery = { __typename?: 'Query', comments: Array<{ __typename?: 'Comment', id: string, comment: string, timestamp: string, author: { __typename?: 'CommentAuthor', id?: string | null, name?: string | null } | { __typename?: 'User', id?: string | null, email: string, firstName?: string | null, lastName?: string | null, name?: string | null }, permissions: { __typename?: 'Permissions', canDelete: boolean, canUpdate: boolean } }> };

export type PapiGqlGetImageFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type PapiGqlGetImageFiltersQuery = { __typename?: 'Query', imageFilters?: Array<{ __typename?: 'ImageFilter', id: string, label: string, description?: string | null } | null> | null };

export type PapiGqlGetBladeDamagesFastQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PapiGqlGetBladeDamagesFastQuery = { __typename?: 'Query', blade?: { __typename?: 'Blade', id: string, damages: Array<{ __typename?: 'Damage', id: string }> } | null };

export type PapiGqlGetSiteTurbinesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PapiGqlGetSiteTurbinesQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, name?: string | null, turbines?: Array<{ __typename?: 'Turbine', id: string, name?: string | null, make?: string | null, model?: string | null, latLng?: Array<number> | null, status?: PapiGqlTurbineStatus | null, inspections?: Array<{ __typename?: 'Inspection', id: string, inspectionDate?: string | null } | null> | null } | null> | null } | null };

export type PapiGqlTurbineInspectionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PapiGqlTurbineInspectionsQuery = { __typename?: 'Query', turbine?: { __typename?: 'Turbine', id: string, inspections?: Array<{ __typename?: 'Inspection', id: string, inspectionStatus?: string | null, inspectionDate?: string | null, type?: { __typename?: 'InspectionType', id: string, name: string } | null, vendor: { __typename?: 'Vendor', id: string, name: string }, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null } | null, campaign?: { __typename?: 'InspectionCampaign', id: string, name: string } | null } | null> | null } | null };

export type PapiGqlTurbineInspectionsFastQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PapiGqlTurbineInspectionsFastQuery = { __typename?: 'Query', turbine?: { __typename?: 'Turbine', id: string, hasSkySpecsInspections?: boolean | null, inspections?: Array<{ __typename?: 'Inspection', id: string } | null> | null } | null };

export type PapiGqlGetBladesQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;


export type PapiGqlGetBladesQuery = { __typename?: 'Query', blades?: Array<{ __typename?: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, status?: PapiGqlBladeStatus | null } | null> | null };

export type PapiGqlDamageDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PapiGqlDamageDetailQuery = { __typename?: 'Query', damage?: { __typename?: 'Damage', id: string, number?: string | null, attrs?: any | null, isConfirmed: boolean, observations?: Array<{ __typename?: 'AnnotationObservation', coordinates?: Array<Array<number | null> | null> | null, descriptors?: Array<string | null> | null, annotationType?: PapiGqlAnnotationTypeReference | null, bladeSide?: string | null, id: string, picture?: { __typename?: 'Picture', id: string, bladeAngle?: string | null, bladeSide?: string | null, bladeChamber?: string | null, filename?: string | null, height?: string | null, towerSide?: string | null, transitionPieceSide?: string | null, inspection?: { __typename?: 'Inspection', id: string, inspectionDate?: string | null, turbine?: { __typename?: 'Turbine', id: string } | null, vendor: { __typename?: 'Vendor', id: string, name: string }, type?: { __typename?: 'InspectionType', id: string, name: string } | null } | null, image?: { __typename?: 'Image', url?: string | null, thumbnailUrl?: string | null, dziSchema?: any | null } | null, source?: { __typename?: 'PictureSource', id: PapiGqlPictureSourceType, label: string, description: string } | null } | null } | null> | null, damageGroup: Array<{ __typename?: 'Damage', id: string, number?: string | null, attrs?: any | null, observations?: Array<{ __typename?: 'AnnotationObservation', id: string, picture?: { __typename?: 'Picture', id: string } | null } | null> | null, tasks?: Array<{ __typename?: 'InspectionTask', id: string, number?: number | null, type: PapiGqlTaskType, description?: string | null, vendor?: string | null, dueDate?: string | null, completedDate?: string | null, status: PapiGqlTaskStatus, tags?: Array<string | null> | null, created: string, createdBy?: { __typename?: 'User', id?: string | null, email: string } | null, workOrder?: { __typename?: 'WorkOrder', id: string, number?: number | null } | null, asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename?: 'InspectTask', id: string, number?: number | null, type: PapiGqlTaskType, description?: string | null, vendor?: string | null, dueDate?: string | null, completedDate?: string | null, status: PapiGqlTaskStatus, tags?: Array<string | null> | null, created: string, damage?: { __typename?: 'Damage', id: string, number?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, email: string } | null, workOrder?: { __typename?: 'WorkOrder', id: string, number?: number | null } | null, asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename?: 'InternalBladeInspectionTask', id: string, number?: number | null, type: PapiGqlTaskType, description?: string | null, vendor?: string | null, dueDate?: string | null, completedDate?: string | null, status: PapiGqlTaskStatus, tags?: Array<string | null> | null, created: string, createdBy?: { __typename?: 'User', id?: string | null, email: string } | null, workOrder?: { __typename?: 'WorkOrder', id: string, number?: number | null } | null, asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename?: 'OtherTask', id: string, number?: number | null, type: PapiGqlTaskType, description?: string | null, vendor?: string | null, dueDate?: string | null, completedDate?: string | null, status: PapiGqlTaskStatus, tags?: Array<string | null> | null, created: string, createdBy?: { __typename?: 'User', id?: string | null, email: string } | null, workOrder?: { __typename?: 'WorkOrder', id: string, number?: number | null } | null, asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename?: 'RepairTask', id: string, number?: number | null, type: PapiGqlTaskType, description?: string | null, vendor?: string | null, dueDate?: string | null, completedDate?: string | null, status: PapiGqlTaskStatus, tags?: Array<string | null> | null, created: string, damage?: { __typename?: 'Damage', id: string, number?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, email: string } | null, workOrder?: { __typename?: 'WorkOrder', id: string, number?: number | null } | null, asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | null> | null }>, tasks?: Array<{ __typename?: 'InspectionTask', id: string, number?: number | null, type: PapiGqlTaskType, description?: string | null, vendor?: string | null, dueDate?: string | null, completedDate?: string | null, status: PapiGqlTaskStatus, tags?: Array<string | null> | null, created: string, createdBy?: { __typename?: 'User', id?: string | null, email: string } | null, workOrder?: { __typename?: 'WorkOrder', id: string, number?: number | null } | null, asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename?: 'InspectTask', id: string, number?: number | null, type: PapiGqlTaskType, description?: string | null, vendor?: string | null, dueDate?: string | null, completedDate?: string | null, status: PapiGqlTaskStatus, tags?: Array<string | null> | null, created: string, damage?: { __typename?: 'Damage', id: string, number?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, email: string } | null, workOrder?: { __typename?: 'WorkOrder', id: string, number?: number | null } | null, asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename?: 'InternalBladeInspectionTask', id: string, number?: number | null, type: PapiGqlTaskType, description?: string | null, vendor?: string | null, dueDate?: string | null, completedDate?: string | null, status: PapiGqlTaskStatus, tags?: Array<string | null> | null, created: string, createdBy?: { __typename?: 'User', id?: string | null, email: string } | null, workOrder?: { __typename?: 'WorkOrder', id: string, number?: number | null } | null, asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename?: 'OtherTask', id: string, number?: number | null, type: PapiGqlTaskType, description?: string | null, vendor?: string | null, dueDate?: string | null, completedDate?: string | null, status: PapiGqlTaskStatus, tags?: Array<string | null> | null, created: string, createdBy?: { __typename?: 'User', id?: string | null, email: string } | null, workOrder?: { __typename?: 'WorkOrder', id: string, number?: number | null } | null, asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename?: 'RepairTask', id: string, number?: number | null, type: PapiGqlTaskType, description?: string | null, vendor?: string | null, dueDate?: string | null, completedDate?: string | null, status: PapiGqlTaskStatus, tags?: Array<string | null> | null, created: string, damage?: { __typename?: 'Damage', id: string, number?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, email: string } | null, workOrder?: { __typename?: 'WorkOrder', id: string, number?: number | null } | null, asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | null> | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, model?: string | null, make?: string | null, status?: PapiGqlTurbineStatus | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null, blade?: { __typename?: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null } | null } | null };

export type PapiGqlGetInspectionVendorsQueryVariables = Exact<{ [key: string]: never; }>;


export type PapiGqlGetInspectionVendorsQuery = { __typename?: 'Query', inspectionVendors?: Array<{ __typename?: 'Vendor', id: string, name: string }> | null };

export type PapiGqlGetLogFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type PapiGqlGetLogFieldsQuery = { __typename?: 'Query', logFields?: Array<{ __typename?: 'LogField', id: string, key: string, displayName: string, type: PapiGqlLogFieldType, options?: Array<string> | null, priority?: number | null, isRequired?: boolean | null, stats?: { __typename?: 'LogStats', sum?: boolean | null, mean?: boolean | null } | null }> | null };

export type PapiGqlEditTaskStepsMutationVariables = Exact<{
  inputs: Array<PapiGqlTaskStepUpdateInput> | PapiGqlTaskStepUpdateInput;
}>;


export type PapiGqlEditTaskStepsMutation = { __typename?: 'Mutation', updateTaskSteps?: Array<{ __typename?: 'TaskStep', id: string, name: string, description?: string | null, completed: boolean, timestamp: string, dataEntry?: any | null, dataSchema?: Array<{ __typename?: 'LogField', id: string, key: string, displayName: string, type: PapiGqlLogFieldType, options?: Array<string> | null, isRequired?: boolean | null, priority?: number | null, formula?: string | null, stats?: { __typename?: 'LogStats', sum?: boolean | null, mean?: boolean | null } | null } | null> | null, permissions: { __typename?: 'Permissions', canUpdate: boolean, canDelete: boolean } } | null> | null };

export type PapiGqlDeleteTaskStepsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PapiGqlDeleteTaskStepsMutation = { __typename?: 'Mutation', deleteTaskSteps?: Array<{ __typename?: 'TaskStep', id: string } | null> | null };

export type PapiGqlTaskStepQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PapiGqlTaskStepQuery = { __typename?: 'Query', taskStep?: { __typename?: 'TaskStep', id: string, name: string, description?: string | null, completed: boolean, timestamp: string, dataEntry?: any | null, dataSchema?: Array<{ __typename?: 'LogField', id: string, key: string, displayName: string, type: PapiGqlLogFieldType, options?: Array<string> | null, isRequired?: boolean | null, priority?: number | null, formula?: string | null, stats?: { __typename?: 'LogStats', sum?: boolean | null, mean?: boolean | null } | null } | null> | null, permissions: { __typename?: 'Permissions', canUpdate: boolean, canDelete: boolean } } | null };

export type PapiGqlTaskStepFragmentPapiFragment = { __typename?: 'TaskStep', id: string, name: string, description?: string | null, completed: boolean, timestamp: string, dataEntry?: any | null, dataSchema?: Array<{ __typename?: 'LogField', id: string, key: string, displayName: string, type: PapiGqlLogFieldType, options?: Array<string> | null, isRequired?: boolean | null, priority?: number | null, formula?: string | null, stats?: { __typename?: 'LogStats', sum?: boolean | null, mean?: boolean | null } | null } | null> | null, permissions: { __typename?: 'Permissions', canUpdate: boolean, canDelete: boolean } };

export type PapiGqlAssetBladeFragmentPapiFragment = { __typename?: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null };

export type PapiGqlAssetLocationFragmentFragment = { __typename?: 'Location', id: string, name?: string | null };

export type PapiGqlAssetTurbineFragmentPapiFragment = { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null };

export type PapiGqlDamageFragmentFragment = { __typename?: 'Damage', id: string, number?: string | null, attrs?: any | null, isConfirmed: boolean, tasks?: Array<{ __typename?: 'InspectionTask', id: string } | { __typename?: 'InspectTask', id: string } | { __typename?: 'InternalBladeInspectionTask', id: string } | { __typename?: 'OtherTask', id: string } | { __typename?: 'RepairTask', id: string } | null> | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, model?: string | null, make?: string | null, status?: PapiGqlTurbineStatus | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null, observations?: Array<{ __typename?: 'AnnotationObservation', coordinates?: Array<Array<number | null> | null> | null, descriptors?: Array<string | null> | null, annotationType?: PapiGqlAnnotationTypeReference | null, bladeSide?: string | null, id: string, picture?: { __typename?: 'Picture', id: string, bladeAngle?: string | null, bladeSide?: string | null, bladeChamber?: string | null, filename?: string | null, height?: string | null, towerSide?: string | null, transitionPieceSide?: string | null, image?: { __typename?: 'Image', url?: string | null, thumbnailUrl?: string | null, dziSchema?: any | null } | null, source?: { __typename?: 'PictureSource', id: PapiGqlPictureSourceType, label: string, description: string } | null, inspection?: { __typename?: 'Inspection', id: string, type?: { __typename?: 'InspectionType', id: string, name: string } | null, vendor: { __typename?: 'Vendor', id: string, name: string } } | null } | null } | null> | null, blade?: { __typename?: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null } | null };

export type PapiGqlDamageListQueryVariables = Exact<{
  schemaId?: InputMaybe<Scalars['ID']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  towerIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filterBy?: InputMaybe<Array<InputMaybe<PapiGqlFilterBy>> | InputMaybe<PapiGqlFilterBy>>;
  sortBy?: InputMaybe<Array<InputMaybe<PapiGqlSortBy>> | InputMaybe<PapiGqlSortBy>>;
  critical?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PapiGqlDamageListQuery = { __typename?: 'Query', damages?: { __typename?: 'DamageList', totalCount: number, items?: Array<{ __typename?: 'Damage', id: string, number?: string | null, attrs?: any | null, isConfirmed: boolean, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, model?: string | null, make?: string | null, status?: PapiGqlTurbineStatus | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null, observations?: Array<{ __typename?: 'AnnotationObservation', coordinates?: Array<Array<number | null> | null> | null, id: string, picture?: { __typename?: 'Picture', id: string, image?: { __typename?: 'Image', url?: string | null, thumbnailUrl?: string | null, dziSchema?: any | null } | null } | null } | null> | null, blade?: { __typename?: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null } | null, tasks?: Array<{ __typename?: 'InspectionTask', id: string, status: PapiGqlTaskStatus, type: PapiGqlTaskType, description?: string | null, dueDate?: string | null, number?: number | null } | { __typename?: 'InspectTask', id: string, status: PapiGqlTaskStatus, type: PapiGqlTaskType, description?: string | null, dueDate?: string | null, number?: number | null, damage?: { __typename?: 'Damage', id: string, number?: string | null, attrs?: any | null, observations?: Array<{ __typename?: 'AnnotationObservation', id: string, picture?: { __typename?: 'Picture', id: string } | null } | null> | null } | null } | { __typename?: 'InternalBladeInspectionTask', id: string, status: PapiGqlTaskStatus, type: PapiGqlTaskType, description?: string | null, dueDate?: string | null, number?: number | null } | { __typename?: 'OtherTask', id: string, status: PapiGqlTaskStatus, type: PapiGqlTaskType, description?: string | null, dueDate?: string | null, number?: number | null } | { __typename?: 'RepairTask', id: string, status: PapiGqlTaskStatus, type: PapiGqlTaskType, description?: string | null, dueDate?: string | null, number?: number | null, damage?: { __typename?: 'Damage', id: string, number?: string | null, attrs?: any | null, observations?: Array<{ __typename?: 'AnnotationObservation', id: string, picture?: { __typename?: 'Picture', id: string } | null } | null> | null } | null } | null> | null } | null> | null } | null };

export type PapiGqlGetLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type PapiGqlGetLocationsQuery = { __typename?: 'Query', locations?: Array<{ __typename?: 'Location', id: string, name?: string | null, slug?: string | null, city?: string | null, state?: string | null, address?: string | null, turbines?: Array<{ __typename?: 'Turbine', id: string, latLng?: Array<number> | null, name?: string | null } | null> | null } | null> | null };

export type PapiGqlGetTaskAssetQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;


export type PapiGqlGetTaskAssetQuery = { __typename?: 'Query', taskAsset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null };

export type PapiGqlCustomerFieldsFragment = { __typename?: 'Customer', id: string, name?: string | null, slug?: string | null };

export type PapiGqlGetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type PapiGqlGetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null, slug?: string | null } | null, customers?: Array<{ __typename?: 'Customer', id: string, name?: string | null, slug?: string | null }> | null, roles: Array<{ __typename?: 'Role', id: string, name: string, actions: Array<string | null>, organizationId: string } | null> } | null };

export type PapiGqlLogFieldFragmentFragment = { __typename?: 'LogField', id: string, key: string, displayName: string, type: PapiGqlLogFieldType, options?: Array<string> | null, priority?: number | null, isRequired?: boolean | null, stats?: { __typename?: 'LogStats', sum?: boolean | null, mean?: boolean | null } | null };

type PapiGqlTaskAssetFragmentPapi_InspectionTask_Fragment = { __typename?: 'InspectionTask', asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null };

type PapiGqlTaskAssetFragmentPapi_InspectTask_Fragment = { __typename?: 'InspectTask', asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null };

type PapiGqlTaskAssetFragmentPapi_InternalBladeInspectionTask_Fragment = { __typename?: 'InternalBladeInspectionTask', asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null };

type PapiGqlTaskAssetFragmentPapi_OtherTask_Fragment = { __typename?: 'OtherTask', asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null };

type PapiGqlTaskAssetFragmentPapi_RepairTask_Fragment = { __typename?: 'RepairTask', asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null };

export type PapiGqlTaskAssetFragmentPapiFragment = PapiGqlTaskAssetFragmentPapi_InspectionTask_Fragment | PapiGqlTaskAssetFragmentPapi_InspectTask_Fragment | PapiGqlTaskAssetFragmentPapi_InternalBladeInspectionTask_Fragment | PapiGqlTaskAssetFragmentPapi_OtherTask_Fragment | PapiGqlTaskAssetFragmentPapi_RepairTask_Fragment;

type PapiGqlTaskFragmentPapi_InspectionTask_Fragment = { __typename?: 'InspectionTask', id: string, number?: number | null, type: PapiGqlTaskType, description?: string | null, vendor?: string | null, dueDate?: string | null, completedDate?: string | null, status: PapiGqlTaskStatus, tags?: Array<string | null> | null, created: string, createdBy?: { __typename?: 'User', id?: string | null, email: string } | null, workOrder?: { __typename?: 'WorkOrder', id: string, number?: number | null } | null, asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null };

type PapiGqlTaskFragmentPapi_InspectTask_Fragment = { __typename?: 'InspectTask', id: string, number?: number | null, type: PapiGqlTaskType, description?: string | null, vendor?: string | null, dueDate?: string | null, completedDate?: string | null, status: PapiGqlTaskStatus, tags?: Array<string | null> | null, created: string, damage?: { __typename?: 'Damage', id: string, number?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, email: string } | null, workOrder?: { __typename?: 'WorkOrder', id: string, number?: number | null } | null, asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null };

type PapiGqlTaskFragmentPapi_InternalBladeInspectionTask_Fragment = { __typename?: 'InternalBladeInspectionTask', id: string, number?: number | null, type: PapiGqlTaskType, description?: string | null, vendor?: string | null, dueDate?: string | null, completedDate?: string | null, status: PapiGqlTaskStatus, tags?: Array<string | null> | null, created: string, createdBy?: { __typename?: 'User', id?: string | null, email: string } | null, workOrder?: { __typename?: 'WorkOrder', id: string, number?: number | null } | null, asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null };

type PapiGqlTaskFragmentPapi_OtherTask_Fragment = { __typename?: 'OtherTask', id: string, number?: number | null, type: PapiGqlTaskType, description?: string | null, vendor?: string | null, dueDate?: string | null, completedDate?: string | null, status: PapiGqlTaskStatus, tags?: Array<string | null> | null, created: string, createdBy?: { __typename?: 'User', id?: string | null, email: string } | null, workOrder?: { __typename?: 'WorkOrder', id: string, number?: number | null } | null, asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null };

type PapiGqlTaskFragmentPapi_RepairTask_Fragment = { __typename?: 'RepairTask', id: string, number?: number | null, type: PapiGqlTaskType, description?: string | null, vendor?: string | null, dueDate?: string | null, completedDate?: string | null, status: PapiGqlTaskStatus, tags?: Array<string | null> | null, created: string, damage?: { __typename?: 'Damage', id: string, number?: string | null } | null, createdBy?: { __typename?: 'User', id?: string | null, email: string } | null, workOrder?: { __typename?: 'WorkOrder', id: string, number?: number | null } | null, asset?: { __typename: 'Blade', id: string, label?: PapiGqlBladeLabel | null, serial?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, turbine?: { __typename?: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | { __typename: 'Location', id: string, name?: string | null } | { __typename: 'Turbine', id: string, name?: string | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null };

export type PapiGqlTaskFragmentPapiFragment = PapiGqlTaskFragmentPapi_InspectionTask_Fragment | PapiGqlTaskFragmentPapi_InspectTask_Fragment | PapiGqlTaskFragmentPapi_InternalBladeInspectionTask_Fragment | PapiGqlTaskFragmentPapi_OtherTask_Fragment | PapiGqlTaskFragmentPapi_RepairTask_Fragment;

export const TaskStepFragmentPapiFragmentDoc = gql`
    fragment TaskStepFragmentPapi on TaskStep {
  id
  name
  description
  completed
  timestamp
  dataSchema {
    id
    key
    displayName
    type
    options
    isRequired
    priority
    formula
    stats {
      sum
      mean
    }
  }
  dataEntry
  permissions {
    canUpdate
    canDelete
  }
}
    `;
export const DamageFragmentFragmentDoc = gql`
    fragment DamageFragment on Damage {
  id
  number
  attrs
  isConfirmed
  tasks {
    id
  }
  turbine {
    id
    name
    model
    make
    status
    location {
      id
      name
    }
  }
  observations {
    id
    ... on AnnotationObservation {
      picture {
        id
        bladeAngle
        bladeSide
        bladeChamber
        filename
        height
        towerSide
        transitionPieceSide
        image {
          url
          thumbnailUrl
          dziSchema
        }
        source {
          id
          label
          description
        }
        inspection {
          id
          type {
            id
            name
          }
          vendor {
            id
            name
          }
        }
      }
      coordinates
      descriptors
      annotationType
      bladeSide
    }
  }
  blade {
    id
    label
    serial
  }
}
    `;
export const CustomerFieldsFragmentDoc = gql`
    fragment CustomerFields on Customer {
  id
  name
  slug
}
    `;
export const LogFieldFragmentFragmentDoc = gql`
    fragment LogFieldFragment on LogField {
  id
  key
  displayName
  type
  options
  priority
  isRequired
  stats {
    sum
    mean
  }
}
    `;
export const AssetLocationFragmentFragmentDoc = gql`
    fragment AssetLocationFragment on Location {
  id
  name
}
    `;
export const AssetTurbineFragmentPapiFragmentDoc = gql`
    fragment AssetTurbineFragmentPapi on Turbine {
  id
  name
  location {
    ...AssetLocationFragment
  }
}
    ${AssetLocationFragmentFragmentDoc}`;
export const AssetBladeFragmentPapiFragmentDoc = gql`
    fragment AssetBladeFragmentPapi on Blade {
  id
  label
  serial
  location {
    ...AssetLocationFragment
  }
  turbine {
    ...AssetTurbineFragmentPapi
  }
}
    ${AssetLocationFragmentFragmentDoc}
${AssetTurbineFragmentPapiFragmentDoc}`;
export const TaskAssetFragmentPapiFragmentDoc = gql`
    fragment TaskAssetFragmentPapi on Task {
  asset {
    id
    __typename
    ... on Location {
      ...AssetLocationFragment
    }
    ... on Turbine {
      ...AssetTurbineFragmentPapi
    }
    ... on Blade {
      ...AssetBladeFragmentPapi
    }
  }
}
    ${AssetLocationFragmentFragmentDoc}
${AssetTurbineFragmentPapiFragmentDoc}
${AssetBladeFragmentPapiFragmentDoc}`;
export const TaskFragmentPapiFragmentDoc = gql`
    fragment TaskFragmentPapi on Task {
  id
  number
  type
  description
  vendor
  dueDate
  completedDate
  status
  tags
  created
  createdBy {
    id
    email
  }
  workOrder {
    id
    number
  }
  ... on RepairTask {
    damage {
      id
      number
    }
  }
  ... on InspectTask {
    damage {
      id
      number
    }
  }
  ...TaskAssetFragmentPapi
}
    ${TaskAssetFragmentPapiFragmentDoc}`;
export const CreateTaskStepsDocument = gql`
    mutation CreateTaskSteps($inputs: [TaskStepCreateInput!]!) {
  createTaskSteps(inputs: $inputs) {
    id
    name
    description
  }
}
    `;
export type PapiGqlCreateTaskStepsMutationFn = Apollo.MutationFunction<PapiGqlCreateTaskStepsMutation, PapiGqlCreateTaskStepsMutationVariables>;

/**
 * __useCreateTaskStepsMutation__
 *
 * To run a mutation, you first call `useCreateTaskStepsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskStepsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskStepsMutation, { data, loading, error }] = useCreateTaskStepsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateTaskStepsMutation(baseOptions?: Apollo.MutationHookOptions<PapiGqlCreateTaskStepsMutation, PapiGqlCreateTaskStepsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PapiGqlCreateTaskStepsMutation, PapiGqlCreateTaskStepsMutationVariables>(CreateTaskStepsDocument, options);
      }
export type CreateTaskStepsMutationHookResult = ReturnType<typeof useCreateTaskStepsMutation>;
export type CreateTaskStepsMutationResult = Apollo.MutationResult<PapiGqlCreateTaskStepsMutation>;
export type CreateTaskStepsMutationOptions = Apollo.BaseMutationOptions<PapiGqlCreateTaskStepsMutation, PapiGqlCreateTaskStepsMutationVariables>;
export const FleetMapDocument = gql`
    query FleetMap {
  turbines {
    id
    name
    latLng
    status
    location {
      id
      name
    }
  }
}
    `;

/**
 * __useFleetMapQuery__
 *
 * To run a query within a React component, call `useFleetMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useFleetMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFleetMapQuery({
 *   variables: {
 *   },
 * });
 */
export function useFleetMapQuery(baseOptions?: Apollo.QueryHookOptions<PapiGqlFleetMapQuery, PapiGqlFleetMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiGqlFleetMapQuery, PapiGqlFleetMapQueryVariables>(FleetMapDocument, options);
      }
export function useFleetMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiGqlFleetMapQuery, PapiGqlFleetMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiGqlFleetMapQuery, PapiGqlFleetMapQueryVariables>(FleetMapDocument, options);
        }
export type FleetMapQueryHookResult = ReturnType<typeof useFleetMapQuery>;
export type FleetMapLazyQueryHookResult = ReturnType<typeof useFleetMapLazyQuery>;
export type FleetMapQueryResult = Apollo.QueryResult<PapiGqlFleetMapQuery, PapiGqlFleetMapQueryVariables>;
export const GetFullscreenImageDocument = gql`
    query GetFullscreenImage($id: ID!, $includeHorizonDamage: Boolean! = false) {
  picture(id: $id) {
    blade {
      id
      label
      serial
      turbine {
        id
        name
        make
        model
        location {
          id
          name
        }
      }
    }
    damages @skip(if: $includeHorizonDamage) {
      id
      number
      tasks {
        id
      }
      observations {
        id
        ... on AnnotationObservation {
          coordinates
          descriptors
          annotationType
          bladeSide
        }
      }
    }
  }
}
    `;

/**
 * __useGetFullscreenImageQuery__
 *
 * To run a query within a React component, call `useGetFullscreenImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullscreenImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullscreenImageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeHorizonDamage: // value for 'includeHorizonDamage'
 *   },
 * });
 */
export function useGetFullscreenImageQuery(baseOptions: Apollo.QueryHookOptions<PapiGqlGetFullscreenImageQuery, PapiGqlGetFullscreenImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiGqlGetFullscreenImageQuery, PapiGqlGetFullscreenImageQueryVariables>(GetFullscreenImageDocument, options);
      }
export function useGetFullscreenImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiGqlGetFullscreenImageQuery, PapiGqlGetFullscreenImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiGqlGetFullscreenImageQuery, PapiGqlGetFullscreenImageQueryVariables>(GetFullscreenImageDocument, options);
        }
export type GetFullscreenImageQueryHookResult = ReturnType<typeof useGetFullscreenImageQuery>;
export type GetFullscreenImageLazyQueryHookResult = ReturnType<typeof useGetFullscreenImageLazyQuery>;
export type GetFullscreenImageQueryResult = Apollo.QueryResult<PapiGqlGetFullscreenImageQuery, PapiGqlGetFullscreenImageQueryVariables>;
export const AddAttachmentDocument = gql`
    mutation AddAttachment($filename: String!, $recordId: ID!) {
  addAttachment(filename: $filename, recordId: $recordId) {
    id
    s3Key
  }
}
    `;
export type PapiGqlAddAttachmentMutationFn = Apollo.MutationFunction<PapiGqlAddAttachmentMutation, PapiGqlAddAttachmentMutationVariables>;

/**
 * __useAddAttachmentMutation__
 *
 * To run a mutation, you first call `useAddAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAttachmentMutation, { data, loading, error }] = useAddAttachmentMutation({
 *   variables: {
 *      filename: // value for 'filename'
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useAddAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<PapiGqlAddAttachmentMutation, PapiGqlAddAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PapiGqlAddAttachmentMutation, PapiGqlAddAttachmentMutationVariables>(AddAttachmentDocument, options);
      }
export type AddAttachmentMutationHookResult = ReturnType<typeof useAddAttachmentMutation>;
export type AddAttachmentMutationResult = Apollo.MutationResult<PapiGqlAddAttachmentMutation>;
export type AddAttachmentMutationOptions = Apollo.BaseMutationOptions<PapiGqlAddAttachmentMutation, PapiGqlAddAttachmentMutationVariables>;
export const DeleteAttachmentDocument = gql`
    mutation DeleteAttachment($id: ID!) {
  deleteAttachment(id: $id)
}
    `;
export type PapiGqlDeleteAttachmentMutationFn = Apollo.MutationFunction<PapiGqlDeleteAttachmentMutation, PapiGqlDeleteAttachmentMutationVariables>;

/**
 * __useDeleteAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttachmentMutation, { data, loading, error }] = useDeleteAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<PapiGqlDeleteAttachmentMutation, PapiGqlDeleteAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PapiGqlDeleteAttachmentMutation, PapiGqlDeleteAttachmentMutationVariables>(DeleteAttachmentDocument, options);
      }
export type DeleteAttachmentMutationHookResult = ReturnType<typeof useDeleteAttachmentMutation>;
export type DeleteAttachmentMutationResult = Apollo.MutationResult<PapiGqlDeleteAttachmentMutation>;
export type DeleteAttachmentMutationOptions = Apollo.BaseMutationOptions<PapiGqlDeleteAttachmentMutation, PapiGqlDeleteAttachmentMutationVariables>;
export const CreateCommentDocument = gql`
    mutation createComment($threadId: ID!, $comment: String!) {
  createComment(input: {threadId: $threadId, comment: $comment}) {
    id
    comment
  }
}
    `;
export type PapiGqlCreateCommentMutationFn = Apollo.MutationFunction<PapiGqlCreateCommentMutation, PapiGqlCreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<PapiGqlCreateCommentMutation, PapiGqlCreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PapiGqlCreateCommentMutation, PapiGqlCreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<PapiGqlCreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<PapiGqlCreateCommentMutation, PapiGqlCreateCommentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation deleteComment($id: ID!) {
  deleteComment(id: $id) {
    id
  }
}
    `;
export type PapiGqlDeleteCommentMutationFn = Apollo.MutationFunction<PapiGqlDeleteCommentMutation, PapiGqlDeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<PapiGqlDeleteCommentMutation, PapiGqlDeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PapiGqlDeleteCommentMutation, PapiGqlDeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<PapiGqlDeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<PapiGqlDeleteCommentMutation, PapiGqlDeleteCommentMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation updateComment($id: ID!, $comment: String!) {
  updateComment(input: {id: $id, comment: $comment}) {
    id
  }
}
    `;
export type PapiGqlUpdateCommentMutationFn = Apollo.MutationFunction<PapiGqlUpdateCommentMutation, PapiGqlUpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<PapiGqlUpdateCommentMutation, PapiGqlUpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PapiGqlUpdateCommentMutation, PapiGqlUpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<PapiGqlUpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<PapiGqlUpdateCommentMutation, PapiGqlUpdateCommentMutationVariables>;
export const GetCommentsDocument = gql`
    query getComments($threadId: ID!) {
  comments(threadId: $threadId) {
    id
    comment
    timestamp
    author {
      ... on User {
        id
        email
        firstName
        lastName
        name
      }
      ... on CommentAuthor {
        id
        name
      }
    }
    permissions {
      canDelete
      canUpdate
    }
  }
}
    `;

/**
 * __useGetCommentsQuery__
 *
 * To run a query within a React component, call `useGetCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsQuery({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useGetCommentsQuery(baseOptions: Apollo.QueryHookOptions<PapiGqlGetCommentsQuery, PapiGqlGetCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiGqlGetCommentsQuery, PapiGqlGetCommentsQueryVariables>(GetCommentsDocument, options);
      }
export function useGetCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiGqlGetCommentsQuery, PapiGqlGetCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiGqlGetCommentsQuery, PapiGqlGetCommentsQueryVariables>(GetCommentsDocument, options);
        }
export type GetCommentsQueryHookResult = ReturnType<typeof useGetCommentsQuery>;
export type GetCommentsLazyQueryHookResult = ReturnType<typeof useGetCommentsLazyQuery>;
export type GetCommentsQueryResult = Apollo.QueryResult<PapiGqlGetCommentsQuery, PapiGqlGetCommentsQueryVariables>;
export const GetImageFiltersDocument = gql`
    query GetImageFilters {
  imageFilters {
    id
    label
    description
  }
}
    `;

/**
 * __useGetImageFiltersQuery__
 *
 * To run a query within a React component, call `useGetImageFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetImageFiltersQuery(baseOptions?: Apollo.QueryHookOptions<PapiGqlGetImageFiltersQuery, PapiGqlGetImageFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiGqlGetImageFiltersQuery, PapiGqlGetImageFiltersQueryVariables>(GetImageFiltersDocument, options);
      }
export function useGetImageFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiGqlGetImageFiltersQuery, PapiGqlGetImageFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiGqlGetImageFiltersQuery, PapiGqlGetImageFiltersQueryVariables>(GetImageFiltersDocument, options);
        }
export type GetImageFiltersQueryHookResult = ReturnType<typeof useGetImageFiltersQuery>;
export type GetImageFiltersLazyQueryHookResult = ReturnType<typeof useGetImageFiltersLazyQuery>;
export type GetImageFiltersQueryResult = Apollo.QueryResult<PapiGqlGetImageFiltersQuery, PapiGqlGetImageFiltersQueryVariables>;
export const GetBladeDamagesFastDocument = gql`
    query GetBladeDamagesFast($id: ID!) {
  blade(id: $id) {
    id
    damages {
      id
    }
  }
}
    `;

/**
 * __useGetBladeDamagesFastQuery__
 *
 * To run a query within a React component, call `useGetBladeDamagesFastQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBladeDamagesFastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBladeDamagesFastQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBladeDamagesFastQuery(baseOptions: Apollo.QueryHookOptions<PapiGqlGetBladeDamagesFastQuery, PapiGqlGetBladeDamagesFastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiGqlGetBladeDamagesFastQuery, PapiGqlGetBladeDamagesFastQueryVariables>(GetBladeDamagesFastDocument, options);
      }
export function useGetBladeDamagesFastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiGqlGetBladeDamagesFastQuery, PapiGqlGetBladeDamagesFastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiGqlGetBladeDamagesFastQuery, PapiGqlGetBladeDamagesFastQueryVariables>(GetBladeDamagesFastDocument, options);
        }
export type GetBladeDamagesFastQueryHookResult = ReturnType<typeof useGetBladeDamagesFastQuery>;
export type GetBladeDamagesFastLazyQueryHookResult = ReturnType<typeof useGetBladeDamagesFastLazyQuery>;
export type GetBladeDamagesFastQueryResult = Apollo.QueryResult<PapiGqlGetBladeDamagesFastQuery, PapiGqlGetBladeDamagesFastQueryVariables>;
export const GetSiteTurbinesDocument = gql`
    query GetSiteTurbines($id: ID!) {
  location(id: $id) {
    id
    name
    turbines {
      id
      name
      make
      model
      latLng
      status
      inspections {
        id
        inspectionDate
      }
    }
  }
}
    `;

/**
 * __useGetSiteTurbinesQuery__
 *
 * To run a query within a React component, call `useGetSiteTurbinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteTurbinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteTurbinesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSiteTurbinesQuery(baseOptions: Apollo.QueryHookOptions<PapiGqlGetSiteTurbinesQuery, PapiGqlGetSiteTurbinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiGqlGetSiteTurbinesQuery, PapiGqlGetSiteTurbinesQueryVariables>(GetSiteTurbinesDocument, options);
      }
export function useGetSiteTurbinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiGqlGetSiteTurbinesQuery, PapiGqlGetSiteTurbinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiGqlGetSiteTurbinesQuery, PapiGqlGetSiteTurbinesQueryVariables>(GetSiteTurbinesDocument, options);
        }
export type GetSiteTurbinesQueryHookResult = ReturnType<typeof useGetSiteTurbinesQuery>;
export type GetSiteTurbinesLazyQueryHookResult = ReturnType<typeof useGetSiteTurbinesLazyQuery>;
export type GetSiteTurbinesQueryResult = Apollo.QueryResult<PapiGqlGetSiteTurbinesQuery, PapiGqlGetSiteTurbinesQueryVariables>;
export const TurbineInspectionsDocument = gql`
    query TurbineInspections($id: ID!) {
  turbine(id: $id) {
    id
    inspections {
      id
      type {
        id
        name
      }
      vendor {
        id
        name
      }
      location {
        id
        name
      }
      turbine {
        id
        name
      }
      campaign {
        id
        name
      }
      inspectionStatus
      inspectionDate
    }
  }
}
    `;

/**
 * __useTurbineInspectionsQuery__
 *
 * To run a query within a React component, call `useTurbineInspectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTurbineInspectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTurbineInspectionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTurbineInspectionsQuery(baseOptions: Apollo.QueryHookOptions<PapiGqlTurbineInspectionsQuery, PapiGqlTurbineInspectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiGqlTurbineInspectionsQuery, PapiGqlTurbineInspectionsQueryVariables>(TurbineInspectionsDocument, options);
      }
export function useTurbineInspectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiGqlTurbineInspectionsQuery, PapiGqlTurbineInspectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiGqlTurbineInspectionsQuery, PapiGqlTurbineInspectionsQueryVariables>(TurbineInspectionsDocument, options);
        }
export type TurbineInspectionsQueryHookResult = ReturnType<typeof useTurbineInspectionsQuery>;
export type TurbineInspectionsLazyQueryHookResult = ReturnType<typeof useTurbineInspectionsLazyQuery>;
export type TurbineInspectionsQueryResult = Apollo.QueryResult<PapiGqlTurbineInspectionsQuery, PapiGqlTurbineInspectionsQueryVariables>;
export const TurbineInspectionsFastDocument = gql`
    query TurbineInspectionsFast($id: ID!) {
  turbine(id: $id) {
    id
    hasSkySpecsInspections
    inspections {
      id
    }
  }
}
    `;

/**
 * __useTurbineInspectionsFastQuery__
 *
 * To run a query within a React component, call `useTurbineInspectionsFastQuery` and pass it any options that fit your needs.
 * When your component renders, `useTurbineInspectionsFastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTurbineInspectionsFastQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTurbineInspectionsFastQuery(baseOptions: Apollo.QueryHookOptions<PapiGqlTurbineInspectionsFastQuery, PapiGqlTurbineInspectionsFastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiGqlTurbineInspectionsFastQuery, PapiGqlTurbineInspectionsFastQueryVariables>(TurbineInspectionsFastDocument, options);
      }
export function useTurbineInspectionsFastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiGqlTurbineInspectionsFastQuery, PapiGqlTurbineInspectionsFastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiGqlTurbineInspectionsFastQuery, PapiGqlTurbineInspectionsFastQueryVariables>(TurbineInspectionsFastDocument, options);
        }
export type TurbineInspectionsFastQueryHookResult = ReturnType<typeof useTurbineInspectionsFastQuery>;
export type TurbineInspectionsFastLazyQueryHookResult = ReturnType<typeof useTurbineInspectionsFastLazyQuery>;
export type TurbineInspectionsFastQueryResult = Apollo.QueryResult<PapiGqlTurbineInspectionsFastQuery, PapiGqlTurbineInspectionsFastQueryVariables>;
export const GetBladesDocument = gql`
    query GetBlades($locationId: ID!) {
  blades(locationId: $locationId) {
    id
    label
    serial
    status
  }
}
    `;

/**
 * __useGetBladesQuery__
 *
 * To run a query within a React component, call `useGetBladesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBladesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBladesQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetBladesQuery(baseOptions: Apollo.QueryHookOptions<PapiGqlGetBladesQuery, PapiGqlGetBladesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiGqlGetBladesQuery, PapiGqlGetBladesQueryVariables>(GetBladesDocument, options);
      }
export function useGetBladesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiGqlGetBladesQuery, PapiGqlGetBladesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiGqlGetBladesQuery, PapiGqlGetBladesQueryVariables>(GetBladesDocument, options);
        }
export type GetBladesQueryHookResult = ReturnType<typeof useGetBladesQuery>;
export type GetBladesLazyQueryHookResult = ReturnType<typeof useGetBladesLazyQuery>;
export type GetBladesQueryResult = Apollo.QueryResult<PapiGqlGetBladesQuery, PapiGqlGetBladesQueryVariables>;
export const DamageDetailDocument = gql`
    query DamageDetail($id: ID!) {
  damage(id: $id) {
    ...DamageFragment
    observations {
      id
      ... on AnnotationObservation {
        picture {
          id
          inspection {
            id
            inspectionDate
            turbine {
              id
            }
            vendor {
              id
              name
            }
            type {
              id
              name
            }
          }
        }
      }
    }
    damageGroup {
      id
      number
      attrs
      observations {
        id
        ... on AnnotationObservation {
          picture {
            id
          }
        }
      }
      tasks {
        ...TaskFragmentPapi
      }
    }
    tasks {
      ...TaskFragmentPapi
    }
  }
}
    ${DamageFragmentFragmentDoc}
${TaskFragmentPapiFragmentDoc}`;

/**
 * __useDamageDetailQuery__
 *
 * To run a query within a React component, call `useDamageDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDamageDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDamageDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDamageDetailQuery(baseOptions: Apollo.QueryHookOptions<PapiGqlDamageDetailQuery, PapiGqlDamageDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiGqlDamageDetailQuery, PapiGqlDamageDetailQueryVariables>(DamageDetailDocument, options);
      }
export function useDamageDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiGqlDamageDetailQuery, PapiGqlDamageDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiGqlDamageDetailQuery, PapiGqlDamageDetailQueryVariables>(DamageDetailDocument, options);
        }
export type DamageDetailQueryHookResult = ReturnType<typeof useDamageDetailQuery>;
export type DamageDetailLazyQueryHookResult = ReturnType<typeof useDamageDetailLazyQuery>;
export type DamageDetailQueryResult = Apollo.QueryResult<PapiGqlDamageDetailQuery, PapiGqlDamageDetailQueryVariables>;
export const GetInspectionVendorsDocument = gql`
    query GetInspectionVendors {
  inspectionVendors {
    id
    name
  }
}
    `;

/**
 * __useGetInspectionVendorsQuery__
 *
 * To run a query within a React component, call `useGetInspectionVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInspectionVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInspectionVendorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInspectionVendorsQuery(baseOptions?: Apollo.QueryHookOptions<PapiGqlGetInspectionVendorsQuery, PapiGqlGetInspectionVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiGqlGetInspectionVendorsQuery, PapiGqlGetInspectionVendorsQueryVariables>(GetInspectionVendorsDocument, options);
      }
export function useGetInspectionVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiGqlGetInspectionVendorsQuery, PapiGqlGetInspectionVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiGqlGetInspectionVendorsQuery, PapiGqlGetInspectionVendorsQueryVariables>(GetInspectionVendorsDocument, options);
        }
export type GetInspectionVendorsQueryHookResult = ReturnType<typeof useGetInspectionVendorsQuery>;
export type GetInspectionVendorsLazyQueryHookResult = ReturnType<typeof useGetInspectionVendorsLazyQuery>;
export type GetInspectionVendorsQueryResult = Apollo.QueryResult<PapiGqlGetInspectionVendorsQuery, PapiGqlGetInspectionVendorsQueryVariables>;
export const GetLogFieldsDocument = gql`
    query GetLogFields {
  logFields {
    ...LogFieldFragment
  }
}
    ${LogFieldFragmentFragmentDoc}`;

/**
 * __useGetLogFieldsQuery__
 *
 * To run a query within a React component, call `useGetLogFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLogFieldsQuery(baseOptions?: Apollo.QueryHookOptions<PapiGqlGetLogFieldsQuery, PapiGqlGetLogFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiGqlGetLogFieldsQuery, PapiGqlGetLogFieldsQueryVariables>(GetLogFieldsDocument, options);
      }
export function useGetLogFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiGqlGetLogFieldsQuery, PapiGqlGetLogFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiGqlGetLogFieldsQuery, PapiGqlGetLogFieldsQueryVariables>(GetLogFieldsDocument, options);
        }
export type GetLogFieldsQueryHookResult = ReturnType<typeof useGetLogFieldsQuery>;
export type GetLogFieldsLazyQueryHookResult = ReturnType<typeof useGetLogFieldsLazyQuery>;
export type GetLogFieldsQueryResult = Apollo.QueryResult<PapiGqlGetLogFieldsQuery, PapiGqlGetLogFieldsQueryVariables>;
export const EditTaskStepsDocument = gql`
    mutation EditTaskSteps($inputs: [TaskStepUpdateInput!]!) {
  updateTaskSteps(inputs: $inputs) {
    ...TaskStepFragmentPapi
  }
}
    ${TaskStepFragmentPapiFragmentDoc}`;
export type PapiGqlEditTaskStepsMutationFn = Apollo.MutationFunction<PapiGqlEditTaskStepsMutation, PapiGqlEditTaskStepsMutationVariables>;

/**
 * __useEditTaskStepsMutation__
 *
 * To run a mutation, you first call `useEditTaskStepsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTaskStepsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTaskStepsMutation, { data, loading, error }] = useEditTaskStepsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useEditTaskStepsMutation(baseOptions?: Apollo.MutationHookOptions<PapiGqlEditTaskStepsMutation, PapiGqlEditTaskStepsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PapiGqlEditTaskStepsMutation, PapiGqlEditTaskStepsMutationVariables>(EditTaskStepsDocument, options);
      }
export type EditTaskStepsMutationHookResult = ReturnType<typeof useEditTaskStepsMutation>;
export type EditTaskStepsMutationResult = Apollo.MutationResult<PapiGqlEditTaskStepsMutation>;
export type EditTaskStepsMutationOptions = Apollo.BaseMutationOptions<PapiGqlEditTaskStepsMutation, PapiGqlEditTaskStepsMutationVariables>;
export const DeleteTaskStepsDocument = gql`
    mutation DeleteTaskSteps($ids: [ID!]!) {
  deleteTaskSteps(ids: $ids) {
    id
  }
}
    `;
export type PapiGqlDeleteTaskStepsMutationFn = Apollo.MutationFunction<PapiGqlDeleteTaskStepsMutation, PapiGqlDeleteTaskStepsMutationVariables>;

/**
 * __useDeleteTaskStepsMutation__
 *
 * To run a mutation, you first call `useDeleteTaskStepsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskStepsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskStepsMutation, { data, loading, error }] = useDeleteTaskStepsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteTaskStepsMutation(baseOptions?: Apollo.MutationHookOptions<PapiGqlDeleteTaskStepsMutation, PapiGqlDeleteTaskStepsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PapiGqlDeleteTaskStepsMutation, PapiGqlDeleteTaskStepsMutationVariables>(DeleteTaskStepsDocument, options);
      }
export type DeleteTaskStepsMutationHookResult = ReturnType<typeof useDeleteTaskStepsMutation>;
export type DeleteTaskStepsMutationResult = Apollo.MutationResult<PapiGqlDeleteTaskStepsMutation>;
export type DeleteTaskStepsMutationOptions = Apollo.BaseMutationOptions<PapiGqlDeleteTaskStepsMutation, PapiGqlDeleteTaskStepsMutationVariables>;
export const TaskStepDocument = gql`
    query TaskStep($id: ID!) {
  taskStep(id: $id) {
    ...TaskStepFragmentPapi
  }
}
    ${TaskStepFragmentPapiFragmentDoc}`;

/**
 * __useTaskStepQuery__
 *
 * To run a query within a React component, call `useTaskStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskStepQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskStepQuery(baseOptions: Apollo.QueryHookOptions<PapiGqlTaskStepQuery, PapiGqlTaskStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiGqlTaskStepQuery, PapiGqlTaskStepQueryVariables>(TaskStepDocument, options);
      }
export function useTaskStepLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiGqlTaskStepQuery, PapiGqlTaskStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiGqlTaskStepQuery, PapiGqlTaskStepQueryVariables>(TaskStepDocument, options);
        }
export type TaskStepQueryHookResult = ReturnType<typeof useTaskStepQuery>;
export type TaskStepLazyQueryHookResult = ReturnType<typeof useTaskStepLazyQuery>;
export type TaskStepQueryResult = Apollo.QueryResult<PapiGqlTaskStepQuery, PapiGqlTaskStepQueryVariables>;
export const DamageListDocument = gql`
    query DamageList($schemaId: ID, $locationIds: [ID!], $towerIds: [ID!], $offset: Int = 0, $limit: Int = 10, $filterBy: [FilterBy], $sortBy: [SortBy], $critical: Boolean) {
  damages(schema: $schemaId, locations: $locationIds, towers: $towerIds, filterBy: $filterBy, sortBy: $sortBy, limit: $limit, offset: $offset, critical: $critical) {
    totalCount
    items {
      id
      number
      attrs
      isConfirmed
      turbine {
        id
        name
        model
        make
        status
        location {
          id
          name
        }
      }
      observations {
        id
        ... on AnnotationObservation {
          picture {
            id
            image {
              url
              thumbnailUrl
              dziSchema
            }
          }
          coordinates
        }
      }
      blade {
        id
        label
        serial
      }
      tasks {
        id
        status
        type
        description
        dueDate
        number
        ... on RepairTask {
          damage {
            id
            number
            attrs
            observations {
              id
              ... on AnnotationObservation {
                picture {
                  id
                }
              }
            }
          }
        }
        ... on InspectTask {
          damage {
            id
            number
            attrs
            observations {
              id
              ... on AnnotationObservation {
                picture {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDamageListQuery__
 *
 * To run a query within a React component, call `useDamageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDamageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDamageListQuery({
 *   variables: {
 *      schemaId: // value for 'schemaId'
 *      locationIds: // value for 'locationIds'
 *      towerIds: // value for 'towerIds'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filterBy: // value for 'filterBy'
 *      sortBy: // value for 'sortBy'
 *      critical: // value for 'critical'
 *   },
 * });
 */
export function useDamageListQuery(baseOptions?: Apollo.QueryHookOptions<PapiGqlDamageListQuery, PapiGqlDamageListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiGqlDamageListQuery, PapiGqlDamageListQueryVariables>(DamageListDocument, options);
      }
export function useDamageListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiGqlDamageListQuery, PapiGqlDamageListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiGqlDamageListQuery, PapiGqlDamageListQueryVariables>(DamageListDocument, options);
        }
export type DamageListQueryHookResult = ReturnType<typeof useDamageListQuery>;
export type DamageListLazyQueryHookResult = ReturnType<typeof useDamageListLazyQuery>;
export type DamageListQueryResult = Apollo.QueryResult<PapiGqlDamageListQuery, PapiGqlDamageListQueryVariables>;
export const GetLocationsDocument = gql`
    query GetLocations {
  locations {
    id
    name
    slug
    city
    state
    address
    turbines {
      id
      latLng
      name
    }
  }
}
    `;

/**
 * __useGetLocationsQuery__
 *
 * To run a query within a React component, call `useGetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationsQuery(baseOptions?: Apollo.QueryHookOptions<PapiGqlGetLocationsQuery, PapiGqlGetLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiGqlGetLocationsQuery, PapiGqlGetLocationsQueryVariables>(GetLocationsDocument, options);
      }
export function useGetLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiGqlGetLocationsQuery, PapiGqlGetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiGqlGetLocationsQuery, PapiGqlGetLocationsQueryVariables>(GetLocationsDocument, options);
        }
export type GetLocationsQueryHookResult = ReturnType<typeof useGetLocationsQuery>;
export type GetLocationsLazyQueryHookResult = ReturnType<typeof useGetLocationsLazyQuery>;
export type GetLocationsQueryResult = Apollo.QueryResult<PapiGqlGetLocationsQuery, PapiGqlGetLocationsQueryVariables>;
export const GetTaskAssetDocument = gql`
    query GetTaskAsset($taskId: ID!) {
  taskAsset(taskId: $taskId) {
    id
    __typename
    ... on Location {
      ...AssetLocationFragment
    }
    ... on Turbine {
      ...AssetTurbineFragmentPapi
    }
    ... on Blade {
      ...AssetBladeFragmentPapi
    }
  }
}
    ${AssetLocationFragmentFragmentDoc}
${AssetTurbineFragmentPapiFragmentDoc}
${AssetBladeFragmentPapiFragmentDoc}`;

/**
 * __useGetTaskAssetQuery__
 *
 * To run a query within a React component, call `useGetTaskAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskAssetQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTaskAssetQuery(baseOptions: Apollo.QueryHookOptions<PapiGqlGetTaskAssetQuery, PapiGqlGetTaskAssetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiGqlGetTaskAssetQuery, PapiGqlGetTaskAssetQueryVariables>(GetTaskAssetDocument, options);
      }
export function useGetTaskAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiGqlGetTaskAssetQuery, PapiGqlGetTaskAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiGqlGetTaskAssetQuery, PapiGqlGetTaskAssetQueryVariables>(GetTaskAssetDocument, options);
        }
export type GetTaskAssetQueryHookResult = ReturnType<typeof useGetTaskAssetQuery>;
export type GetTaskAssetLazyQueryHookResult = ReturnType<typeof useGetTaskAssetLazyQuery>;
export type GetTaskAssetQueryResult = Apollo.QueryResult<PapiGqlGetTaskAssetQuery, PapiGqlGetTaskAssetQueryVariables>;
export const GetUserDocument = gql`
    query getUser {
  user {
    id
    customer {
      ...CustomerFields
    }
    customers {
      ...CustomerFields
    }
    roles {
      id
      name
      actions
      organizationId
    }
  }
}
    ${CustomerFieldsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<PapiGqlGetUserQuery, PapiGqlGetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PapiGqlGetUserQuery, PapiGqlGetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PapiGqlGetUserQuery, PapiGqlGetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PapiGqlGetUserQuery, PapiGqlGetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<PapiGqlGetUserQuery, PapiGqlGetUserQueryVariables>;